  (() => {
    'use strict';

    // ─── Data ───
    const MATRIX = {
      sensitive: {
        rebuild: { cleanse:{name:'Gentle Cleanse Melt',vol:'150ml',price:44}, hydrateAm:{name:'Pure Calm Cream',vol:'50ml',price:62}, hydratePm:{name:'Pure Calm Night Cream',vol:'50ml',price:64}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} },
        reclaim: { cleanse:{name:'Gentle Cleanse Melt',vol:'150ml',price:44}, tone:{name:'Hydra Soft Toner',vol:'200ml',price:38}, prevent:{name:'Vitamin Shield Gel',vol:'30ml',price:56}, support:{name:'Biome Jelly Serum',vol:'30ml',price:72}, hydrateAm:{name:'Pure Calm Cream',vol:'50ml',price:62}, hydratePm:{name:'Pure Calm Night Cream',vol:'50ml',price:64}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} },
        revitalize: { cleanse:{name:'Gentle Cleanse Melt',vol:'150ml',price:44}, tone:{name:'Hydra Soft Toner',vol:'200ml',price:38}, prevent:{name:'Vitamin Bright Serum',vol:'30ml',price:64}, support:{name:'Biome Jelly Serum',vol:'30ml',price:72}, treat:{name:'Active Renew Serum',vol:'30ml',price:68}, hydrateAm:{name:'Pure Calm Cream',vol:'50ml',price:62}, hydratePm:{name:'Pure Calm Night Cream',vol:'50ml',price:64}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} }
      },
      dry: {
        rebuild: { cleanse:{name:'Silk Balanced Milk',vol:'190ml',price:42}, hydrateAm:{name:'Hydra Day Cream',vol:'50ml',price:58}, hydratePm:{name:'Rich Barrier Night Cream',vol:'50ml',price:78}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} },
        reclaim: { cleanse:{name:'Silk Balanced Milk',vol:'190ml',price:42}, tone:{name:'Hydra Soft Toner',vol:'200ml',price:38}, prevent:{name:'Vitamin Shield Gel',vol:'30ml',price:56}, support:{name:'Collagen Glow Serum',vol:'30ml',price:74}, hydrateAm:{name:'Hydra Day Cream',vol:'50ml',price:58}, hydratePm:{name:'Rich Barrier Night Cream',vol:'50ml',price:78}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} },
        revitalize: { cleanse:{name:'Silk Balanced Milk',vol:'190ml',price:42}, tone:{name:'Hydra Soft Toner',vol:'200ml',price:38}, prevent:{name:'Vitamin Bright Serum',vol:'30ml',price:64}, support:{name:'Peptide Firm Serum',vol:'30ml',price:84}, treat:{name:'Active Renew Serum',vol:'30ml',price:68}, hydrateAm:{name:'Hydra Day Cream',vol:'50ml',price:58}, hydratePm:{name:'Rich Barrier Night Cream',vol:'50ml',price:78}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} }
      },
      breakout: {
        rebuild: { cleanse:{name:'Fresh Clarifying Gel',vol:'145ml',price:36}, hydrateAm:{name:'Weightless Hydra Gel',vol:'50ml',price:54}, hydratePm:{name:'Hydra Matte Cream',vol:'50ml',price:58}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} },
        reclaim: { cleanse:{name:'Fresh Clarifying Gel',vol:'145ml',price:36}, tone:{name:'Refine Calm Toner',vol:'200ml',price:42}, prevent:{name:'Vitamin Shield Gel',vol:'30ml',price:56}, support:{name:'Even Bright Gel Cream',vol:'50ml',price:58}, hydrateAm:{name:'Weightless Hydra Gel',vol:'50ml',price:54}, hydratePm:{name:'Hydra Matte Cream',vol:'50ml',price:58}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} },
        revitalize: { cleanse:{name:'Fresh Clarifying Gel',vol:'145ml',price:36}, tone:{name:'Refine Calm Toner',vol:'200ml',price:42}, prevent:{name:'Vitamin Bright Serum',vol:'30ml',price:64}, support:{name:'Even Bright Gel Cream',vol:'50ml',price:58}, treat:{name:'Active Renew Serum',vol:'30ml',price:68}, hydrateAm:{name:'Weightless Hydra Gel',vol:'50ml',price:54}, hydratePm:{name:'Hydra Matte Cream',vol:'50ml',price:58}, protect:{name:'Daily SPF Veil',vol:'50ml',price:0,planned:true} }
      }
    };

    const PROD = {
      'Gentle Cleanse Melt':'gentle-cleanse-melt-150ml','Silk Balanced Milk':'silk-balanced-milk-190ml','Fresh Clarifying Gel':'fresh-clarifying-gel-145ml',
      'Hydra Soft Toner':'hydra-soft-toner-200ml','Refine Calm Toner':'refine-calm-toner-200ml',
      'Vitamin Bright Serum':'vitamin-bright-serum-30ml','Vitamin Shield Gel':'vitamin-shield-gel-30ml',
      'Active Renew Serum':'active-renew-serum-30ml','Biome Jelly Serum':'biome-jelly-serum-30ml',
      'Peptide Firm Serum':'peptide-firm-serum-30ml','Collagen Glow Serum':'collagen-glow-serum-30ml',
      'Pure Calm Cream':'pure-calm-cream-50ml','Pure Calm Night Cream':'pure-calm-night-cream-50ml',
      'Hydra Day Cream':'hydra-day-cream-50ml','Rich Barrier Night Cream':'rich-barrier-night-cream-50ml',
      'Weightless Hydra Gel':'weightless-hydra-gel-50ml','Hydra Matte Cream':'hydra-matte-cream-50ml',
      'Even Bright Gel Cream':'even-bright-gel-cream-50ml'
    };

    const STAGE_ORDER = ['rebuild','reclaim','revitalize'];
    const STAGE_NAMES = { rebuild:'Rebuild', reclaim:'Reclaim', revitalize:'Revitalize' };
    const TYPE_NAMES  = { sensitive:'Sensitive', dry:'Dry', breakout:'Breakout' };
    const STRESS_NAMES = { low:'Low', medium:'Medium', high:'High' };
    const TYPES_ORDER = ['sensitive','dry','breakout'];

    // Two-to-three-word answers for the matrix-overlay dialog (replaces TYPE_ATTR / STAGE_ATTR / STRESS_ATTR
    // for the in-dialog selections recap only). Aligned with the Q-page button sublines.
    const TYPE_DIALOG  = { sensitive:'Inflames easily — settles slow', dry:'Loses moisture by midday', breakout:'Carrying more than its share' };
    const STAGE_DIALOG = { rebuild:'Easing into it',                   reclaim:'Building on what works', revitalize:'Targeted treatment' };
    const STRESS_DIALOG = { low:'Steady, well-rested',                 medium:'Carrying some load',     high:'Running heavy' };

    // Provision · Support layer — face-relevant Provision SKUs mapped to the Renewal arc's Support step.
    // Per /01_canon/provision-doctrine.md §3 — these are 5-zone Provision SKUs with active step "support (05)".
    // Customer-facing framing: early-access upsell. "Being considered for adoption into your Arc."
    // Filter rule: shared across all types (all-skin-types appropriate); cell-overlap not a concern since these
    // are Provision (not in any Renewal cell).
    const PROVISION_SUPPORT = [
      { name:'Biome Refresh Mist', handle:'biome-refresh-mist-100ml', vol:'100ml', price:23,
        tag:'Prebiotic mist for midday microbiome reset — barrier dew, on demand.' },
      { name:'Caffeine Wake Gel', handle:'caffeine-wake-gel-20ml', vol:'30ml', price:21,
        tag:'Wakes the under-eye and face. Circulation as ritual — daily, with intention.' },
      { name:'Deep Nourish Oil', handle:'deep-nourish-oil-15ml', vol:'15ml', price:25,
        tag:'Eleven oils — argan, cloudberry, blueberry, jojoba. The full ritual in travel form.' },
      { name:'Radiance Oil Blend', handle:'radiance-oil-blend-30ml', vol:'30ml', price:29,
        tag:'Twelve organic oils — sea buckthorn, raspberry, rosehip, jojoba. One press, full-spectrum.' }
    ];

    // ─── Live data from window.FYA_DATA (injected by section.liquid) ───
    // Overlays live Shopify prices, images, URLs, availability + variant IDs onto
    // MATRIX + PROVISION_SUPPORT. Hardcoded values above are fallback only —
    // Shopify is source-of-truth per /holy/_drafts/find-your-arc-shopify-port-memo-2026-06-04.md.
    // Cells (arc canon) and axis education blocks also flow through FYA_DATA when
    // populated via the arc_cell / arc_*_axis metaobjects.
    const LIVE = (typeof window !== 'undefined' && window.FYA_DATA) ? window.FYA_DATA : null;
    if (LIVE && LIVE.products) {
      const enrich = (p) => {
        if (!p || !p.name) return;
        const handle = (typeof PROD !== 'undefined' && PROD[p.name]) || p.handle;
        if (!handle) return;
        const live = LIVE.products[handle];
        if (!live) return;
        p.handle = handle;
        p.price = parseFloat(live.price);
        p.image = live.image;
        p.url = live.url;
        p.available = live.available;
        p.variantId = live.variantId;
        p.subscriptionEligible = live.subscriptionEligible;
        p.liveTitle = live.title;
      };
      for (const t in MATRIX) {
        for (const s in MATRIX[t]) {
          for (const step in MATRIX[t][s]) {
            enrich(MATRIX[t][s][step]);
          }
        }
      }
      PROVISION_SUPPORT.forEach(enrich);
    }

    // Matrix descriptor — single evolving sentence (Option C from proposal)
    // Q1 alone: TYPE_PHRASE[t]
    // Q1+Q2: TYPE_NOUN[t] + ', ' + STAGE_TAIL[s]
    // Q1+Q2+Q3: above + STRESS_TAIL[stress] as second sentence
    const TYPE_PHRASE = {
      sensitive: 'Sensitive — meets the world loudly.',
      dry:       'Dry — asks for hydration first.',
      breakout:  'Oilier — clears without escalating.'
    };
    const TYPE_NOUN = {
      sensitive: 'Sensitive',
      dry:       'Dry',
      breakout:  'Oilier'
    };
    const STAGE_TAIL = {
      rebuild:    'starting from the foundation.',
      reclaim:    'going deeper.',
      revitalize: 'actively correcting.'
    };
    const STRESS_TAIL = {
      low:    'Stress is low — the barrier holds, and the Arc moves with you.',
      medium: 'Stress is workable — the Ritual is the practice that brings it down.',
      high:   'Stress is high — the Ritual is the steady line. Pace to your breath, not the clock.'
    };

    // How-to-Apply — order + brief gesture per Step. AM and PM use the same Step set the customer's Arc holds,
    //   filtered to which Steps run in each window. "Movement" labels the somatic Method moment (faded, not bold).
    //   Gesture phrases are 4-6 words — they teach without lecturing.
    // AM = Cleanse → Tone → Prevent → Hydrate → Protect (no Treat — actives are PM only per Renewal canon).
    // PM = Cleanse → Tone → Treat → Support → Hydrate (no SPF — hydratePm is the closing seal).
    const APPLY_AM_ORDER = ['cleanse','tone','prevent','hydrateAm','protect'];
    const APPLY_PM_ORDER = ['cleanse','tone','treat','support','hydratePm'];
    // Step → Movement mapping per Tiana's Method canon (/01_canon/the-method.md):
    //   Cleanse + Tone → Open (Receive). Prevent + Hydrate → Soften (Prepare). Treat → Work (Transform).
    //   Support → Ground (Restore). Protect → Protect (Preserve).
    // Each Movement renders with its Purpose ("Open · Receive") on the Step card so the customer sees what
    // the somatic Movement is for, not just its label.
    const APPLY_MOVEMENT = {
      cleanse:    'Open · Receive',
      tone:       'Open · Receive',
      prevent:    'Soften · Prepare',
      hydrateAm:  'Soften · Prepare',
      hydratePm:  'Soften · Prepare',
      treat:      'Work · Transform',
      support:    'Ground · Restore',
      protect:    'Protect · Preserve'
    };
    // APPLY_NARRATIVE — per-cell scripture-format AM/PM narratives. 9 cells × 2 windows = 18 narratives.
    // Each has a preface (italic, sets the tone for this Type + Stage) + verses (numbered, one per Step).
    // {wordmark} token is replaced at render time with the footnote-letter-prefixed hølyX link.
    // Empathetically attuned: sensitive = calming, dry = nourishing, breakout = clarifying.
    // Stage tones: rebuild = simplest/foundational, reclaim = building/calibrating, revitalize = correction-on-stable-base.
    const APPLY_NARRATIVE = {
      sensitive: {
        rebuild: {
          am: {
            preface: "Three Steps. The simplest morning your reactive skin has been asking for. Nothing forced; the barrier given space to rebuild.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Warm and brief — never hot. Massage between palms first, then onto dry skin in slow concentric circles from the center outward. Forty-five seconds. Rinse with a cool cloth." },
              { step:'hydrateAm', text:"Apply {wordmark} while skin is still slightly damp; humectants need ambient water to draw into the corneocytes. Two pumps, pressed warm, never rubbed." },
              { step:'protect',   text:"Finish with {wordmark}. Two fingers' worth, mineral, fragrance-free. Fifteen minutes before sun. This is the final layer of the day." }
            ]
          },
          pm: {
            preface: "Two Steps at night. The reactive barrier repairs while you sleep; this ritual gives it space to do so.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Warm cloth, slow press; apply to dry skin first. Massage upward and outward, two minutes. The day comes off without force." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight — ceramide-rich, designed to work with the skin's overnight repair cycle (cellular turnover peaks 11 PM to 4 AM). Let it settle for two minutes." }
            ]
          }
        },
        reclaim: {
          am: {
            preface: "Five Steps. Your barrier has settled; now the practice adds calibration — never escalation. Each layer asks the same question: does this calm or stir.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Warm and brief; massage between palms first, then onto dry skin in slow concentric circles. Forty-five seconds. Rinse cool." },
              { step:'tone',      text:"Press in {wordmark} next — two presses while skin is still damp. Toner restores pH to its native 5.5; don't let the surface fully dry." },
              { step:'prevent',   text:"Then {wordmark} — one pump, warmed between fingertips, pressed gently into the barrier. Stable antioxidants defend without provoking. Wait sixty seconds." },
              { step:'hydrateAm', text:"Apply {wordmark} while barely damp. Two pumps, pressed warm." },
              { step:'protect',   text:"Finish with {wordmark}. Two fingers' worth, mineral, sensitive-skin formulated. Fifteen minutes before sun." }
            ]
          },
          pm: {
            preface: "Four Steps at night. Support replaces SPF; the barrier rebuilds while you rest.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Warm cloth, slow press; massage upward two minutes." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin. At night, toning re-balances pH and softens the surface for what follows." },
              { step:'support',   text:"Then {wordmark} — two drops warmed between palms, patted into still-damp skin. Biome-balancing peptides restore the surface ecology the day disrupted." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight. Massage upward; let it settle for two minutes." }
            ]
          }
        },
        revitalize: {
          am: {
            preface: "Five Steps. The barrier holds; you've earned active depth. Morning stays calm — the work happens at night.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Warm and brief; forty-five seconds of slow concentric circles. Cool cloth rinse." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin. Wait thirty seconds." },
              { step:'prevent',   text:"Then {wordmark} — vitamin C plus ferulic, pressed into the barrier. Brightening without harsh actives. Wait sixty seconds." },
              { step:'hydrateAm', text:"Apply {wordmark} while barely damp. Two pumps, pressed warm." },
              { step:'protect',   text:"Finish with {wordmark}. Mineral, two fingers' worth, fifteen minutes before sun." }
            ]
          },
          pm: {
            preface: "Five Steps at night. This is where the Repair happens. Treat is here — calibrated for reactive skin. Begin twice weekly; build slowly.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Slow circles, two minutes. Warm cloth rinse." },
              { step:'tone',      text:"Press in {wordmark} — two presses, damp skin. Wait five full minutes before the next; actives need a calmer surface." },
              { step:'treat',     text:"Then {wordmark} — pea-sized, away from eye and lip line. Encapsulated retinoid releases over six to eight hours. Begin twice weekly; build to nightly over six to eight weeks." },
              { step:'support',   text:"Then {wordmark} — two drops warmed between palms, patted into damp skin. Microbiome support calms what the active stirs." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight. Massage upward; let it settle." }
            ]
          }
        }
      },
      dry: {
        rebuild: {
          am: {
            preface: "Three Steps. Dry skin asks for water before anything else. This morning delivers it — nothing extra, nothing aggressive.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark} — a lipid-replenishing milk, never stripping. Warm cloth, slow press, sixty seconds. Avoid hot water; it accelerates trans-epidermal water loss." },
              { step:'hydrateAm', text:"Apply {wordmark} while skin is still damp. Humectants need ambient water to bind — this is the key. Two pumps, pressed warm. Allow two minutes to fully absorb." },
              { step:'protect',   text:"Finish with {wordmark}. Two fingers' worth, mineral. Fifteen minutes before sun. SPF doubles as a barrier against trans-epidermal water loss." }
            ]
          },
          pm: {
            preface: "Two Steps at night. Deep replenishment closes the cycle the day opened.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Lipid-replenishing milk, warm cloth, two minutes upward." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight — a noticeably thicker layer than morning. Lipid-led, ceramide-rich, designed to work with the skin's overnight repair cycle. Massage upward — neck, jaw, cheekbones, temples. Let it settle." }
            ]
          }
        },
        reclaim: {
          am: {
            preface: "Five Steps. Hydration becomes resilience as layers build — water, oils, antioxidants, all working to hold what you give.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Lipid-replenishing milk, warm cloth, sixty seconds. Avoid hot water." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin. Glycerin and panthenol layer water under the cream that follows." },
              { step:'prevent',   text:"Then {wordmark} — one pump, warmed between fingertips, pressed in. Vitamin C protects barrier lipids from oxidation. Wait sixty seconds." },
              { step:'hydrateAm', text:"Apply {wordmark} while still damp. Two pumps, pressed warm. Two minutes to absorb." },
              { step:'protect',   text:"Finish with {wordmark}. Two fingers' worth, fifteen minutes before sun." }
            ]
          },
          pm: {
            preface: "Four Steps at night. Marine collagen and ceramides rebuild what the day pulled apart.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Warm cloth, two minutes upward." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin; don't let it fully dry." },
              { step:'support',   text:"Then {wordmark} — two drops of marine collagen plus peptide complex, warmed and patted into damp skin. Plumps from beneath the surface." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight — rich barrier cream, deeply restorative. Massage upward; let it settle." }
            ]
          }
        },
        revitalize: {
          am: {
            preface: "Five Steps. The base is nourished; the barrier resilient. Morning is the day's defense; correction is held for night.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Lipid-replenishing milk, sixty seconds. Cool cloth rinse." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin. Wait thirty seconds." },
              { step:'prevent',   text:"Then {wordmark} — vitamin C brightening serum, pressed into the barrier. Wait sixty seconds." },
              { step:'hydrateAm', text:"Apply {wordmark} while damp. Two pumps, pressed warm." },
              { step:'protect',   text:"Finish with {wordmark}. Mineral, two fingers' worth, fifteen minutes before sun." }
            ]
          },
          pm: {
            preface: "Five Steps at night. Active correction joins a nourished base — the full expression of your Arc.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Two minutes upward." },
              { step:'tone',      text:"Press in {wordmark} — damp skin. Wait five full minutes before the next." },
              { step:'treat',     text:"Then {wordmark} — pea-sized, encapsulated retinoid for resilient skin. Away from eye and lip line. Begin twice weekly; build slowly over six to eight weeks." },
              { step:'support',   text:"Then {wordmark} — two drops of peptide complex, patted into damp skin. Firms while it nourishes." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight. Ceramide-rich. Massage upward; let it settle." }
            ]
          }
        }
      },
      breakout: {
        rebuild: {
          am: {
            preface: "Three Steps. Clarifying — never punishing. Congestion is communication; this morning makes space for balance to return.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark} — salicylic acid at gentle concentration. Clears congestion at the pore without stripping the surface. Warm water, sixty seconds, slow circles. Rinse cool." },
              { step:'hydrateAm', text:"Apply {wordmark} while skin is damp — lightweight, weightless gel, designed for oil-prone skin. Two pumps, pressed in." },
              { step:'protect',   text:"Finish with {wordmark}. Two fingers' worth, mineral, fifteen minutes before sun. Non-comedogenic." }
            ]
          },
          pm: {
            preface: "Two Steps at night. Clear and weightless; the surface settles while you rest.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Salicylic acid clears the day. Sixty to ninety seconds. Warm cloth rinse." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight — non-comedogenic, hydrating without weight, designed for oil-prone skin overnight." }
            ]
          }
        },
        reclaim: {
          am: {
            preface: "Five Steps. The surface clarifies; now prevention and brightening join the practice. Niacinamide, antioxidants, biome-balanced. No stripping.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Salicylic acid clears; sixty seconds. Rinse cool." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin. Niacinamide tightens pore appearance." },
              { step:'prevent',   text:"Then {wordmark} — vitamin C plus ferulic, pressed in. Brightening defense. Wait sixty seconds." },
              { step:'hydrateAm', text:"Apply {wordmark} while damp. Lightweight gel — pressed, never rubbed." },
              { step:'protect',   text:"Finish with {wordmark}. Mineral, non-comedogenic, fifteen minutes before sun." }
            ]
          },
          pm: {
            preface: "Four Steps at night. Support and clarity together; the cycle slows.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Salicylic acid; sixty seconds. Warm cloth." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin." },
              { step:'support',   text:"Then {wordmark} — niacinamide gel cream, patted into damp skin. Brightens post-blemish marks while it hydrates." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight. Non-comedogenic. Designed for oil-prone overnight repair." }
            ]
          }
        },
        revitalize: {
          am: {
            preface: "Five Steps. The base holds; brightening and prevention layer onto a clarified surface. Correction stays at night.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Sixty seconds. Rinse cool." },
              { step:'tone',      text:"Press in {wordmark} — two presses on damp skin." },
              { step:'prevent',   text:"Then {wordmark} — vitamin C brightening serum, pressed in. Wait sixty seconds." },
              { step:'hydrateAm', text:"Apply {wordmark} while damp. Two pumps." },
              { step:'protect',   text:"Finish with {wordmark}. Mineral, fifteen minutes before sun." }
            ]
          },
          pm: {
            preface: "Five Steps at night. Pattern-breaking work begins — retinoid layered onto a clarified, supported base. Begin gently; build over weeks.",
            verses: [
              { step:'cleanse',   text:"Begin with {wordmark}. Salicylic acid clears; sixty seconds. Warm cloth." },
              { step:'tone',      text:"Press in {wordmark} — damp skin. Wait five full minutes before actives." },
              { step:'treat',     text:"Then {wordmark} — pea-sized, encapsulated retinoid. Away from eye and lip line. Begin twice weekly; build to nightly over six to eight weeks." },
              { step:'support',   text:"Then {wordmark} — niacinamide gel cream, patted into damp skin. Calms what the active stirs." },
              { step:'hydratePm', text:"Finish with {wordmark} in its night weight. Non-comedogenic." }
            ]
          }
        }
      }
    };
    // (APPLY_FRAGMENT kept as legacy fallback for cells/tabs without a NARRATIVE entry — should not trigger.)
    const APPLY_FRAGMENT = {
      cleanse: {
        am: "Begin with {wordmark}. If you can, take a brief warm bath instead of a shower — steam softens the barrier and primes circulation. Massage between palms first to warm the formula, then onto dry skin in slow concentric circles from the center of the face outward. Sixty seconds, minimum. Rinse with a cool cloth to seal the surface.",
        pm: "Begin with {wordmark}. At day's end, draw a warm bath if you can — the parasympathetic shift begins the moment you submerge. Apply to dry skin first, massaging upward and outward in slow circles. Two minutes. Rinse with a warm cloth."
      },
      tone: {
        am: "Press in {wordmark} next, two presses while skin is still damp from rinsing. Toner returns the surface to its native pH of 5.5 (cleansing trends alkaline) and primes the next layer. Wait thirty seconds.",
        pm: "Press in {wordmark} the same way — two presses on damp skin. At night, toning re-balances pH and softens the surface for the active layers that follow."
      },
      prevent: {
        am: "Then {wordmark}: one pump warmed between fingertips, pressed into the barrier from the cheekbones inward. Stable vitamin C and ferulic acid form an antioxidant shield against the day's oxidative load — UV, blue light, particulate. Wait sixty seconds for it to bind."
      },
      treat: {
        pm: "Wait five full minutes after toning, then apply {wordmark}. Pea-sized is enough for the full face. Press, don't rub; avoid the eye area and lip line entirely. Encapsulated retinoid releases over six to eight hours, which is why this is a PM Step only. Begin twice weekly and build to nightly over six to eight weeks as your barrier signals tolerance."
      },
      support: {
        pm: "Then {wordmark} — two drops warmed between palms, patted into still-damp skin (don't let the prior layer fully dry). Microbiome-balancing peptides restore the surface ecology that the day's stressors disrupt."
      },
      hydrateAm: {
        am: "Apply {wordmark} while skin is still slightly damp — humectants need ambient water to draw into the corneocytes. Two pumps. Press warm, never rub. Allow two minutes to absorb."
      },
      hydratePm: {
        pm: "Finish with {wordmark} — a noticeably thicker layer than the morning cream. Ceramide-rich, designed to work with the skin's overnight repair cycle, when cellular turnover peaks (between 11 PM and 4 AM). Massage upward — neck, jawline, cheekbones, temples. Let it settle for two minutes. The night seals."
      },
      protect: {
        am: "Finish with {wordmark} — two fingers' worth, about a quarter teaspoon, for the full face, neck, and ears. Apply fifteen minutes before sun exposure to give mineral filters time to set. Reapply every two hours outdoors. This is the final layer of the day; it stays on until you cleanse tonight."
      }
    };
    // APPLY_HOW — short clause for use in compact contexts (legacy; APPLY_DESCRIPTION is the primary copy now).
    const APPLY_HOW = {
      cleanse:    'warm cloth, slow press',
      tone:       'two presses, never wiped',
      prevent:    'one pump, pressed in',
      support:    'two drops, patted into damp skin',
      treat:      'pea-sized, away from eye and lip',
      hydrateAm:  'layer warm, then breathe',
      hydratePm:  'layer thick, settled',
      protect:    'half a finger, blended across'
    };
    // Legacy stress-keyed cadence — kept as fallback only. Replaced by APPLY_CADENCE_CELL per-cell narratives.
    const APPLY_CADENCE = {
      low:    'Daily, both windows. Add the targeted Step 3-4 nights a week. Listen for redness, scale back if you see it.',
      medium: 'Daily, both windows. Targeted Step twice a week to start. The Ritual is the down-regulation — pace to your breath, not the clock.',
      high:   'Lighten the load. AM essentials only on the heaviest days. PM in full when you can. The Ritual is the steady line; the practice itself is the medicine. Add the targeted Step only when your skin is asking — never as a push.'
    };
    // APPLY_CADENCE_CELL — per-cell cadence paragraph, plain helpful voice. Well-educated and informed without
    // performing it; reads like a guide explaining how to keep the practice going.
    const APPLY_CADENCE_CELL = {
      sensitive: {
        rebuild:    "Run this morning and evening, every day. There are no actives in this stage — just the basics, done consistently. Reactive skin rebuilds its barrier over about eight to twelve weeks when the practice stays steady. Watch for redness or tightness; if you see either, slow down or skip a day. The goal at this stage is consistency, not progress.",
        reclaim:    "Run this morning and evening, every day. When you're ready to add a new layer, add only one at a time and give it two full weeks before evaluating. If your skin feels calm, hold the cadence. If it feels tender or reactive, drop the most recent layer and let the barrier reset for another two weeks before trying again. Reactive skin rebuilds trust slowly — give it the room to do so.",
        revitalize: "Run the morning ritual every day. The evening ritual with the treatment serum runs two to three nights a week to start; you can work up to four nights over six to eight weeks if your skin signals tolerance. On the off-nights, follow the Reclaim evening (no treatment serum). Retinoid changes take time: turnover becomes visible around week six, brightness around week ten, depth by month four. Stay with it; resist the urge to push faster than your barrier allows."
      },
      dry: {
        rebuild:    "Run this morning and evening, every day. Dry skin holds hydration when application is consistent; irregular use is what undoes the work. Drink water throughout the day (about half your body weight in ounces is a good baseline), and run a humidifier in your bedroom during dry seasons. You should see visible plumpness in two to three weeks, with deeper sustained hydration around the eight-to-ten-week mark.",
        reclaim:    "Run this morning and evening, every day. Hydration depth comes from continuity rather than intensity, so give the full layered practice at least six weeks of consistency before evaluating any single product. Marine collagen and ceramides work cumulatively — you won't see results from a single application, but the eight-week trend tells the real story. Humidify in dry seasons, and lower the temperature of your shower.",
        revitalize: "Run the morning ritual every day. The evening ritual with the treatment serum runs three nights a week to start; you can work up to nightly over eight to ten weeks. Active correction on dry skin takes patience — the barrier needs to hold while turnover increases. Use tightness as your gauge: if your skin feels tight by mid-afternoon, the previous night was too much, and you should pull back. Repair compounds at the four-to-six-month mark."
      },
      breakout: {
        rebuild:    "Run this morning and evening, every day. Salicylic acid at this gentle concentration can run daily indefinitely; the goal is steady clearance, not stripping. Pay attention to where congestion appears and how your sebum patterns shift over time. Most patterns ease over six to eight weeks of consistent practice as the cycle slows and the surface clarifies. Try not to add more or escalate when results take longer than you'd like — patience beats overcorrection.",
        reclaim:    "Run this morning and evening, every day. Brightening with niacinamide and vitamin C runs nightly; the cumulative effect on post-blemish marks takes about six to ten weeks to register. Track pore appearance and oil distribution rather than counting individual blemishes — those will fluctuate with hormonal cycles regardless of your practice. The ritual modulates intensity and recovery, not whether breakouts happen.",
        revitalize: "Run the morning ritual every day. The evening ritual with the treatment serum runs two nights a week to start; you can work up to four nights over six to eight weeks as your surface signals tolerance. On the off-nights, follow the Reclaim evening (no treatment serum). Retinoid on breakout-prone skin can purge initially — accelerating latent congestion to the surface in weeks two through four. This is expected, not a setback. Stay with it; clearance typically begins around week six."
      }
    };

    // First-person phrases — sticky-bar label (sentence-case italic Garamond)
    const TYPE_CONFIRM = {
      sensitive: 'My skin is sensitive and reactive.',
      dry:       'My skin is dry and asks for hydration.',
      breakout:  'My skin runs oilier and holds congestion.'
    };
    // Reveal-page position caption — narrative form. "For [type phrase], [stage phrase], [stress phrase]."
    // Reads as a guide naming the customer's coordinate, not a list of picks.
    const TYPE_CAPTION = {
      sensitive: 'For sensitive and reactive skin',
      dry:       'For dry skin that asks for hydration',
      breakout:  'For oilier skin holding congestion'
    };
    const STAGE_CAPTION = {
      rebuild:    'starting from a clean foundation',
      reclaim:    'building on what works',
      revitalize: 'ready for active correction'
    };
    const STRESS_CAPTION = {
      low:    'under steady conditions',
      medium: 'carrying a workable load',
      high:   'with cortisol running heavy'
    };

    // Descriptor confirms — plain first-person, customer voice. Distinct from button labels.
    // No brand vocabulary yet (Arc, cortisol) — that's earned on the reveal page, not the Q-pages.
    const STAGE_CONFIRM = {
      rebuild:    'I\'m getting my basics down.',
      reclaim:    'I\'m refining what I have.',
      revitalize: 'I\'m working on real change.'
    };
    const STRESS_CONFIRM = {
      low:    'I\'m rested and clear.',
      medium: 'I\'m a little stretched today.',
      high:   'I\'m running on empty.'
    };
    // Attribute sub-lines — pulled from buttons, drive the matrix overlay
    const TYPE_ATTR = {
      sensitive: 'Inflamed easily. Quick to redness. Fragrance-shy.',
      dry:       'Standard tolerance. Asks for hydration.',
      breakout:  'Oilier zones. Clogged. Recurring blemishes.'
    };
    const STAGE_ATTR = {
      rebuild:    'A clean, simple foundation.',
      reclaim:    'Building on what works.',
      revitalize: 'Targeted treatment, active correction.'
    };
    const STRESS_ATTR = {
      low:    'Steady; well-rested.',
      medium: 'Carrying some load.',
      high:   'Running heavy. Burnt or close.'
    };

    // 9 named Arcs — placeholders for redline
    // ARC_NAMES — aligned to /03_expressions/ritual-care/arcs/renewal/named-cells.md (locked v1 2026-06-01).
    // Pattern: "The {Calm|Hydrated|Clear} {Foundation|Layered|Restoration}".
    // Arc names — locked 2026-06-02 (Preston). Pattern is type-vocabulary + stage-word.
    //   Sensitive uses Pure (tier) for rebuild + Calm (descriptor) for reclaim/revitalize.
    //   Dry uses Hydrated across the row with start/build/repair stage words.
    //   Breakout uses "Daily {action}" framing — clarifying / refining / resetting.
    const ARC_NAMES = {
      sensitive: { rebuild:'Pure Start',        reclaim:'Calm Build',     revitalize:'Calm Repair' },
      dry:       { rebuild:'Hydrated Start',    reclaim:'Hydrated Build', revitalize:'Hydrated Repair' },
      breakout:  { rebuild:'Daily Clarifying',  reclaim:'Daily Refining', revitalize:'Daily Resetting' }
    };

    // RAIL_INGREDIENTS — 3 hero actives per Arc cell, each tied to the customer's Type + Stage at this moment.
    // First draft for Preston to redline. Aim: name the active, then a single line of what it does for THEIR skin
    // at THIS stage (not generic). Voice: clinical-but-warm, no marketing puff.
    const RAIL_INGREDIENTS = {
      sensitive: {
        rebuild: [
          { name:'Ceramides',          role:'Rebuilds the barrier lipids reactive skin loses faster than it makes.' },
          { name:'Niacinamide',        role:'Quiets flushing and the small reactions you read as overresponse.' },
          { name:'Hyaluronic acid',    role:'Lightweight water — no fragrance, no friction.' }
        ],
        reclaim: [
          { name:'Vitamin C (stable)', role:'Defends the barrier you\'ve just stabilized — without escalating reactivity.' },
          { name:'Antioxidant gel',    role:'Settles oxidative inflammation before it shows on the surface.' },
          { name:'Biome peptides',     role:'Restores the microbiome layer reactive skin runs short on.' }
        ],
        revitalize: [
          { name:'Biome peptides',     role:'Restores the microbiome layer reactive skin runs short on.' },
          { name:'Encapsulated retinoid', role:'Cellular turnover, delivered slow. Calibrated for reactive thresholds.' },
          { name:'Marine collagen',    role:'Plumps from beneath — visible firmness without aggression.' }
        ]
      },
      dry: {
        rebuild: [
          { name:'Sodium hyaluronate', role:'Water-binding across molecular weights — surface to deep.' },
          { name:'Squalane',           role:'The lipid dry skin runs short on. Restores supple feel fast.' },
          { name:'Glycerin',           role:'Humectant that holds water in when the air keeps pulling it out.' }
        ],
        reclaim: [
          { name:'Polyglutamic acid',  role:'Holds 4× more water than HA — for skin that keeps losing it.' },
          { name:'Marine collagen',    role:'Plumps from beneath the surface. Visible firmness across the day.' },
          { name:'Cold-pressed oils',  role:'Lipid replenishment that nourishes without weight.' }
        ],
        revitalize: [
          { name:'Bakuchiol',          role:'Plant retinoid — cellular turnover without the dryness.' },
          { name:'Peptide complex',    role:'Firms overnight while the moisturizer holds.' },
          { name:'Ceramide blend',     role:'Deep barrier restoration — dry skin can take active correction now.' }
        ]
      },
      breakout: {
        rebuild: [
          { name:'Salicylic acid',     role:'Clears congestion at the pore without stripping the surface.' },
          { name:'Niacinamide',        role:'Calms post-blemish inflammation and visible redness.' },
          { name:'Zinc PCA',           role:'Regulates sebum so the cycle slows.' }
        ],
        reclaim: [
          { name:'Encapsulated retinol', role:'Resurfaces without aggravating — the breakout cycle gets shorter.' },
          { name:'Niacinamide (5%)',     role:'Brightens post-blemish marks and tightens pore appearance.' },
          { name:'Tea tree + green tea', role:'Antibacterial + antioxidant — clears without harsh dryness.' }
        ],
        revitalize: [
          { name:'AHA + BHA blend',    role:'Multi-acid turnover — for skin ready to break the pattern.' },
          { name:'Encapsulated retinoid', role:'Active correction on a stable base. Calibrated, not aggressive.' },
          { name:'Centella + panthenol', role:'Calms what the actives stir up — clears without inflammation.' }
        ]
      }
    };

    // Reveal narrative templates
    // Reveal-pane narrative — 9 cells, single flowing paragraph each, official-descriptor voice.
    // Rule: each paragraph uses "arc" OR "renewal" exactly once — never both. Rendered upright in Merriweather.
    // Religious lexicon ("sacred", "offering") placed deliberately in the two Foundation cells; other cells secular.
    // Per-axis education paragraphs — Recognition → Reframing → Invitation 3-beat per HØLY voice (plain language,
    // religious lexicon only in ARC_NARRATIVE rebuild cells, not here). Each lands the empathetic beat first, then
    // hands off to the Arc's response. Per POV "State Precedes Outcome" powers STRESS_EDU.
    const TYPE_EDU = {
      sensitive: "Your skin reads inputs as threats — fragrance, friction, a change in temperature. That isn't fragility; it's a barrier running on thinner ceramide reserves than most. The Arc meets it where it is — less force, layered hydration, no surprises.",
      dry:       "Water leaves your skin faster than it takes it back. The tightness you feel by midday isn't a moment of dehydration — it's the cycle catching up. Every Step either gives water or holds it. Hydrate before you treat; protect before you wait.",
      breakout:  "Congestion isn't a discipline problem. It's communication — your skin asking for less escalation, not more. The Arc clears without punishment: calm first, then correction, then balance."
    };
    const STAGE_EDU = {
      rebuild:    "You're not behind. You're starting from a clean foundation — four Steps, the floor every Arc rests on. Cleanse, hydrate, protect. Build that solidly and everything else compounds.",
      reclaim:    "What you have is working — now you're adding calibration. Seven Steps, more nuance. Tone, prevention, and barrier support join your foundation. The practice gains depth without losing rhythm.",
      revitalize: "Your base holds. Now correction joins it. Eight Steps, targeted change. Active turnover earned by everything that came before. This is the full Arc — not aggressive, just complete."
    };
    const STRESS_EDU = {
      low:    "Cortisol low, barrier intact — your skin is meeting the Arc at full capacity. Cadence stays steady. The practice compounds because your nervous system isn't fighting it.",
      medium: "You're carrying a workable load. The Ritual itself is what brings it down. Pace to your breath, not the clock — the Arc adapts to the day you're in, not the day you wish you had.",
      high:   "Cortisol elevated, barrier loosening. Now the Ritual is the steady line. What matters most is the return — five minutes in the practice resets more than five minutes off your phone. Don't add Steps here; receive what you already named."
    };

    // ARC_NARRATIVE — 9 cells. Recognition → Reframing → Invitation 3-beat. Religious lexicon (sacred, offering)
    // appears only in the rebuild cells per /02_brand/religious-lexicon.md ("sparingly, intentionally"). Each cell
    // uses "Arc" exactly once, ties the named Arc to the customer's coordinate, and avoids marketing softeners.
    // Closing handoff phrase ("This is where routine becomes Ritual.") lands at end of each paragraph — brand-canon
    // line that retires "routine" customer-facing from the results page forward.
    const ARC_NARRATIVE = {
      sensitive: {
        rebuild:    "The simplest Arc your skin has been asking for: fewer steps, pure formulas, more rest. Cleanse, hydrate, protect — the sacred basics that meet a reactive barrier without testing it. A foundation built so everything else can compound on it. This is where routine becomes Ritual.",
        reclaim:    "Built on what already works, this Arc layers tone, prevention, and barrier support — adding depth without trade-off. Progress is measured in calm, not correction. Every Step passes through the question your skin asks: does this calm or escalate? This is where routine becomes Ritual.",
        revitalize: "With the foundation steady, targeted correction joins. Eight Steps calibrated for skin that runs reactive — powerful actives delivered slow. Transformation without aggression. The practice your skin earned. This is where routine becomes Ritual."
      },
      dry: {
        rebuild:    "Dry skin asks for water before anything else, so this Arc begins with the body's most basic need. Cleanse, hydrate, protect — nothing extra, nothing aggressive. An offering of nourishment where it's needed most. This is where routine becomes Ritual.",
        reclaim:    "Hydration is more than moisture; it's resilience. This Arc layers tone, prevention, and barrier support onto the foundation — helping skin hold what you give it through the day. Less depletion. More return. This is where routine becomes Ritual.",
        revitalize: "When skin is nourished, it's ready for more. This Arc pairs deep hydration with targeted treatment — addressing visible concerns without sacrificing comfort. A fuller expression of skin that holds water and shows it. This is where routine becomes Ritual."
      },
      breakout: {
        rebuild:    "Congested skin isn't a problem to solve — it's communicating. This Arc focuses on clarity through simplicity: remove what overwhelms, calm what's inflamed, make space for balance to return. The sacred opposite of punishment. This is where routine becomes Ritual.",
        reclaim:    "Balance begins when the cycle breaks. This Arc introduces supportive Steps designed to reduce congestion without disturbing the healthy skin beneath. Clear skin should never cost healthy skin. Calm first; clarity follows. This is where routine becomes Ritual.",
        revitalize: "You're ready to change the pattern. This Arc combines a stable foundation with focused correction — addressing persistent concerns while preserving the equilibrium you've earned. Deliberate. Measured. Lasting. This is where routine becomes Ritual."
      }
    };

    const NEW_AT_STAGE = { rebuild:['cleanse','hydrateAm','hydratePm','protect'], reclaim:['tone','prevent','support'], revitalize:['treat'] };
    const STEP_LABEL = { cleanse:'Cleanse', tone:'Tone', prevent:'Prevent', support:'Support', treat:'Treat', hydrateAm:'Hydrate', hydratePm:'Hydrate', protect:'Protect' };
    // Subtitles update per stage — Q1 explains Arc, Q2/Q3 acknowledge progress
    const SUBTITLES = {
      q1:     "See your Renewal Arc — in three answers.",
      q2:     'Practice deepens with stage.',
      q3:     'Cortisol tunes the cadence.',
      gate:   '',
      reveal: ''
    };
    const STEP_DESCRIBED = {
      sensitive: { cleanse:'Warm cloth, ceramide melt. The day comes off slow.', tone:'Soft hydra-toner. Resets pH without stripping.', prevent:'Antioxidant gel. Quiets what would otherwise inflame.', support:'Biome jelly. Microbiome-balancing peptides.', treat:'Active renewal serum. Patient correction.', hydrateAm:'Pure Calm Cream. Calming morning hydration.', hydratePm:'Pure Calm Night Cream. Overnight barrier repair.', protect:'Daily SPF veil. Mineral, fragrance-free.' },
      dry:       { cleanse:'Silk Balanced Milk. Lipid-replenishing wash.', tone:'Soft hydra-toner. Layers water under the cream.', prevent:'Antioxidant gel. Defends barrier from oxidative stress.', support:'Collagen glow serum. Marine collagen + peptide complex.', treat:'Active renewal serum. Smoother turnover, even tone.', hydrateAm:'Hydra Day Cream. Light, water-rich.', hydratePm:'Rich Barrier Night Cream. Dense, lipid-restoring.', protect:'Daily SPF veil. Mineral, fragrance-free.' },
      breakout:  { cleanse:'Fresh Clarifying Gel. Salicylic acid, oil-free.', tone:'Refine Calm Toner. Niacinamide-led pore tightener.', prevent:'Antioxidant gel. Reduces post-blemish marks.', support:'Even Bright Gel Cream. Brightens without weight.', treat:'Active renewal serum. Resurfaces, calms congestion.', hydrateAm:'Weightless Hydra Gel. Hyaluronic, oil-free.', hydratePm:'Hydra Matte Cream. Hydrates without shine.', protect:'Daily SPF veil. Mineral, fragrance-free.' }
    };
    const WHY = {
      sensitive: { rebuild:'Slow and gentle. Just the essentials — nothing aggressive while the barrier settles.', reclaim:'Your barrier has settled. Stage two layers in tone, prevent, and support — calming formulas, never escalating.', revitalize:'Steady. The full Arc with gentle active correction layered in.' },
      dry:       { rebuild:'Hydration anchored. Milk cleanser, day cream, rich evening cream.', reclaim:'Hydration holds. Stage two layers in tone, prevent, and collagen support.', revitalize:'Foundations steady. Stage three brings targeted correction without compromise.' },
      breakout:  { rebuild:'Clear and weightless. Gel cleanser, light AM hydration, matte PM finish.', reclaim:'Surface clarified. Stage two adds tone, prevent, and niacinamide.', revitalize:'Base holds. Stage three layers active correction without aggravation.' }
    };
    const STRESS_MODIFIER = {
      steady:   'Parasympathetic. The barrier holds. The Arc moves with you — Steps assimilate.',
      carrying: 'A workable load. The Ritual itself is the down-regulation. Keep the cadence.',
      high:     'Cortisol elevated; barrier loosens. The Arc helps — but the practice is what holds the line. Slow Open. Long Soften.',
      maxed:    'Inflammation runs loud. Stay in the Steps you\'ve named. This isn\'t the week to add — this is the week to receive.',
      bottomed: 'Cortisol on, oxytocin low. The Ritual is the medicine. Pace to breath, not clock. Recovery is the work.'
    };

    const AR_DISCOUNT = 0.10;

    // ─── Cell / axis canon enrichment from FYA_DATA.cells.* + .typeAxis/.stageAxis/.stressAxis ───
    // Override hardcoded constants when matching metaobject records exist (renewal_matrix_cell,
    // renewal_matrix_type_axis, renewal_matrix_stage_axis, renewal_stress_modulator). Cells keyed by
    // `${type}-${stage}` handle (e.g. "sensitive-rebuild"). Axes keyed by single slug ("sensitive",
    // "rebuild", "low"). Falls through to hardcoded constants for any missing field. This lets Tiana
    // edit canon copy from Shopify admin without code deploys; reverts to constants if metaobjects
    // are unpopulated. Scaffold ready for the bulk-populate after Tiana review of the canary cell.
    if (LIVE && LIVE.cells) {
      for (const t of ['sensitive','dry','breakout']) {
        for (const s of ['rebuild','reclaim','revitalize']) {
          const cell = LIVE.cells[t + '-' + s];
          if (!cell) continue;
          if (cell.arc_name && ARC_NAMES[t]) ARC_NAMES[t][s] = cell.arc_name;
          if (cell.arc_narrative && ARC_NARRATIVE[t]) ARC_NARRATIVE[t][s] = cell.arc_narrative;
          if (cell.apply_cadence && APPLY_CADENCE_CELL[t]) APPLY_CADENCE_CELL[t][s] = cell.apply_cadence;
          if (cell.apply_narrative_am) {
            try {
              const am = typeof cell.apply_narrative_am === 'string' ? JSON.parse(cell.apply_narrative_am) : cell.apply_narrative_am;
              if (APPLY_NARRATIVE[t] && APPLY_NARRATIVE[t][s]) APPLY_NARRATIVE[t][s].am = am;
            } catch (e) { console.warn('[fya] cell.apply_narrative_am parse failed for', t, s, e); }
          }
          if (cell.apply_narrative_pm) {
            try {
              const pm = typeof cell.apply_narrative_pm === 'string' ? JSON.parse(cell.apply_narrative_pm) : cell.apply_narrative_pm;
              if (APPLY_NARRATIVE[t] && APPLY_NARRATIVE[t][s]) APPLY_NARRATIVE[t][s].pm = pm;
            } catch (e) { console.warn('[fya] cell.apply_narrative_pm parse failed for', t, s, e); }
          }
          if (cell.rail_ingredients) {
            try {
              const list = typeof cell.rail_ingredients === 'string' ? JSON.parse(cell.rail_ingredients) : cell.rail_ingredients;
              if (Array.isArray(list) && RAIL_INGREDIENTS[t]) RAIL_INGREDIENTS[t][s] = list;
            } catch (e) { console.warn('[fya] cell.rail_ingredients parse failed for', t, s, e); }
          }
        }
      }
    }
    if (LIVE && LIVE.typeAxis) {
      for (const k of ['sensitive','dry','breakout']) {
        const ax = LIVE.typeAxis[k];
        if (!ax) continue;
        if (ax.caption && TYPE_CAPTION) TYPE_CAPTION[k] = ax.caption;
        if (ax.confirm && TYPE_CONFIRM) TYPE_CONFIRM[k] = ax.confirm;
        if (ax.attr    && TYPE_ATTR)    TYPE_ATTR[k]    = ax.attr;
        if (ax.dialog  && TYPE_DIALOG)  TYPE_DIALOG[k]  = ax.dialog;
        if (ax.phrase  && TYPE_PHRASE)  TYPE_PHRASE[k]  = ax.phrase;
        if (ax.noun    && TYPE_NOUN)    TYPE_NOUN[k]    = ax.noun;
        if (ax.edu     && TYPE_EDU)     TYPE_EDU[k]     = ax.edu;
      }
    }
    if (LIVE && LIVE.stageAxis) {
      for (const k of ['rebuild','reclaim','revitalize']) {
        const ax = LIVE.stageAxis[k];
        if (!ax) continue;
        if (ax.caption && STAGE_CAPTION) STAGE_CAPTION[k] = ax.caption;
        if (ax.confirm && STAGE_CONFIRM) STAGE_CONFIRM[k] = ax.confirm;
        if (ax.attr    && STAGE_ATTR)    STAGE_ATTR[k]    = ax.attr;
        if (ax.dialog  && STAGE_DIALOG)  STAGE_DIALOG[k]  = ax.dialog;
        if (ax.tail    && STAGE_TAIL)    STAGE_TAIL[k]    = ax.tail;
        if (ax.edu     && STAGE_EDU)     STAGE_EDU[k]     = ax.edu;
      }
    }
    if (LIVE && LIVE.stressAxis) {
      for (const k of ['low','medium','high']) {
        const ax = LIVE.stressAxis[k];
        if (!ax) continue;
        if (ax.caption && STRESS_CAPTION) STRESS_CAPTION[k] = ax.caption;
        if (ax.confirm && STRESS_CONFIRM) STRESS_CONFIRM[k] = ax.confirm;
        if (ax.attr    && STRESS_ATTR)    STRESS_ATTR[k]    = ax.attr;
        if (ax.dialog  && STRESS_DIALOG)  STRESS_DIALOG[k]  = ax.dialog;
        if (ax.tail    && STRESS_TAIL)    STRESS_TAIL[k]    = ax.tail;
        if (ax.edu     && STRESS_EDU)     STRESS_EDU[k]     = ax.edu;
      }
    }
    const answers = {};
    // Per-product remove state — set of Step keys the customer has unselected on the reveal page.
    // Cleared every time the customer (re-)enters the reveal stage from earlier Q-pages.
    let removedSteps = new Set();

    // ─── DOM ───
    const root = document.getElementById('fya');
    const panes = {
      q1:      root.querySelector('[data-fya-pane="q1"]'),
      q2:      root.querySelector('[data-fya-pane="q2"]'),
      q3:      root.querySelector('[data-fya-pane="q3"]'),
      gate:    root.querySelector('[data-fya-pane="gate"]'),
      reveal:  root.querySelector('[data-fya-pane="reveal"]'),
      locking: root.querySelector('[data-fya-pane="locking"]'),
    };
    const framing       = root.querySelector('[data-fya-framing]');
    const backLabel     = document.querySelector('[data-fya-back-label]');
    const progressEls   = document.querySelectorAll('[data-fya-progress]');
    const markers       = document.querySelectorAll('[data-fya-marker]');
    const sticky        = document.querySelector('[data-fya-sticky]');
    const stickyLabel   = document.querySelector('[data-fya-sticky-label]');
    const stickyText    = document.querySelector('[data-fya-continue-text]');
    const continueBtns  = document.querySelectorAll('[data-fya-continue]');
    const continueBtn   = continueBtns[0]; // Legacy single-ref retained for sticky-CTA-specific paths.
    const backBtn       = document.querySelector('[data-fya-back]');
    const matrixMobile      = document.querySelector('[data-fya-matrix-mobile]');
    const matrixDesktop     = document.querySelector('[data-fya-matrix-desktop]');
    const matrixDescr       = document.querySelector('[data-fya-matrix-descriptor]');
    const matrixDescrMobile = document.querySelector('[data-fya-matrix-descriptor-mobile]');

    // ─── Progress ───
    function computeProgress(key, ans) {
      if (key === 'q1') return ans.q1 ? 17 : 0;
      if (key === 'q2') return ans.q2 ? 50 : 33;
      if (key === 'q3') return ans.q3 ? 83 : 67;
      if (key === 'gate' || key === 'reveal') return 100;
      return 0;
    }
    function setProgress(pct) {
      progressEls.forEach(el => { el.style.width = pct + '%'; });
      markers.forEach(m => {
        const id = m.dataset.fyaMarker;
        const pos = id === '1' ? 0 : id === '2' ? 33 : id === '3' ? 67 : 100;
        m.dataset.passed = (pct >= pos - 1) ? '1' : '0';
      });
    }

    // ─── Matrix render ───
    // Hover-aware context — hover values fill in for un-committed picks.
    // Reads `root.dataset.hover` (set on .fya-answer mouseenter, cleared on mouseleave). Only fills the
    // current-stage slot if no answer is committed for it yet. Hovering after the user has picked is a no-op.
    function getMatrixContext() {
      let t = answers.q1 || null;
      let s = answers.q2 || null;
      let stress = answers.q3 || null;
      const hover = root && root.dataset.hover;
      if (hover && root.dataset.stage !== 'reveal') {
        const [hq, hv] = hover.split(':');
        if (hq === 'q1' && !t) t = hv;
        else if (hq === 'q2' && !s) s = hv;
        else if (hq === 'q3' && !stress) stress = hv;
      }
      return { t, s, stress };
    }

    function renderMatrix() {
      const { t, s, stress } = getMatrixContext();
      const html = buildMatrixHTML(t, s, stress);
      matrixMobile.innerHTML = html;
      matrixDesktop.innerHTML = html;
      const matrixReveal = document.querySelector('[data-fya-matrix-reveal]');
      if (matrixReveal) matrixReveal.innerHTML = html;
      const matrixInset = document.querySelector('[data-fya-matrix-inset]');
      if (matrixInset) matrixInset.innerHTML = html;
      renderMatrixDescriptor(t, s, stress);
    }
    function buildMatrixHTML(t, stage, stress) {
      // Reveal stage shows real Stage names (Rebuild/Reclaim/Revitalize); all earlier stages show generic Stage 1/2/3
      const isReveal = root && root.dataset.stage === 'reveal';
      const stageLabels = isReveal
        ? { rebuild: 'Rebuild', reclaim: 'Reclaim', revitalize: 'Revitalize' }
        : { rebuild: 'Stage 1', reclaim: 'Stage 2', revitalize: 'Stage 3' };

      // Stress modulates the active cell — data-stress drives CSS variants (LOW = lighter, HIGH = umber-shifted).
      const stressAttr = stress ? ` data-stress="${stress}"` : '';
      let h = `<div class="fya-matrix-block"${stressAttr}>`;
      // Corner — axis-legend stack: "Skin Stage →" sits above (over the X labels) and "Skin Type ↓" below
      // (over the Y labels). Hidden via CSS on the inset (200px) matrix on the reveal hero.
      h += '<div class="fya-matrix-corner">' +
             '<span class="fya-axis-legend" data-axis="x">Stage<span class="fya-axis-arrow">→</span></span>' +
             '<span class="fya-axis-legend" data-axis="y">Type<span class="fya-axis-arrow">↓</span></span>' +
           '</div>';
      // X axis labels (top row, cols 2-4)
      STAGE_ORDER.forEach((s, idx) => {
        const active = (s === stage) ? '1' : '0';
        h += `<div class="fya-x-label" data-active="${active}" style="grid-column:${idx + 2};">${stageLabels[s]}</div>`;
      });
      // Y axis labels (col 1, rows 2-4)
      TYPES_ORDER.forEach((tp, idx) => {
        const active = (tp === t) ? '1' : '0';
        h += `<div class="fya-y-label" data-active="${active}" style="grid-row:${idx + 2};">${TYPE_NAMES[tp]}</div>`;
      });
      // The 3x3 matrix grid
      h += '<div class="fya-matrix-grid">';
      TYPES_ORDER.forEach(tp => {
        STAGE_ORDER.forEach(s => {
          const rowAct = (tp === t) ? '1' : '0';
          const colAct = (s === stage) ? '1' : '0';
          h += `<div class="fya-cell" data-row-active="${rowAct}" data-col-active="${colAct}"></div>`;
        });
      });

      // Pulse dot lives inside grid; overlay lives in matrix-block (sibling of grid) — positioned relative to block
      const rowIdx = t      ? TYPES_ORDER.indexOf(t)      : -1;
      const colIdx = stage  ? STAGE_ORDER.indexOf(stage)  : -1;
      const settled = !!(t && stage && stress);
      const stageKey = root && root.dataset.stage;

      // Pulse dot — appears once Skin Type (Q1) is picked.
      // Q1 only (no stage yet): dot floats at the row's center column, gentler pulse.
      // Q2 settled (stage picked): dot snaps to the customer's cell, full pulse.
      // Q3 settled: animation stops, dot rests.
      if (t) {
        const colForDot = (colIdx === -1) ? 1 : colIdx; // center column when stage unknown
        const dotX = ((colForDot + 0.5) / 3) * 100;
        const dotY = ((rowIdx + 0.5) / 3) * 100;
        const dotMode = settled ? 'settled' : (stage ? 'q2' : 'q1');
        h += `<div class="fya-pulse-dot" data-mode="${dotMode}" data-settled="${settled ? '1' : '0'}" style="left:${dotX}%; top:${dotY}%;"></div>`;
      }

      h += '</div>'; // /grid — close matrix-grid before overlay

      // Glassy overlay — labeled sub-lines (Skin Type · Skin Routine · Stress Level) under "Your Selections" eyebrow.
      // Dialog-only copy: 2–3 word answers, not full sentence attributes.
      const overlayLines = [];
      if (t)      overlayLines.push(`<p><span class="fya-overlay-num">Skin Type</span>${TYPE_DIALOG[t]}</p>`);
      if (stage)  overlayLines.push(`<p><span class="fya-overlay-num">Skin Routine</span>${STAGE_DIALOG[stage]}</p>`);
      if (stress) overlayLines.push(`<p><span class="fya-overlay-num">Stress Level</span>${STRESS_DIALOG[stress]}</p>`);

      // Melt-down on reveal: skip the dialog overlay so the full matrix is visible. Selections "story" lives in
      // the page narrative + Arc name H2 + (CSS-faded) inactive rows/cols of the matrix itself.
      if (overlayLines.length > 0 && !isReveal) {
        const effRow = (rowIdx === -1) ? 0 : rowIdx;
        const effCol = (colIdx === -1) ? 1 : colIdx;

        // Vertical anchor — percentages of block height (approximate, X label row + 3 cell rows + gaps)
        // Row 0 → overlay below row 1 (top ~41%); Row 1 → below row 2 (top ~71%); Row 2 → above row 3 (bottom ~30%)
        let posCSS = '';
        if (effRow === 0)      { posCSS += `top:41%; bottom:auto;`; }
        else if (effRow === 1) { posCSS += `top:71%; bottom:auto;`; }
        else                   { posCSS += `bottom:30%; top:auto;`; }

        // Horizontal anchor — relative to block (320px on mobile)
        if (effCol === 0)      { posCSS += `left:-2px; right:auto;`; }
        else if (effCol === 1) { posCSS += `left:50%; right:auto; transform:translateX(-50%);`; }
        else                   { posCSS += `right:-2px; left:auto;`; }

        const showReveal = settled && root && root.dataset.stage !== 'reveal';
        const revealHTML = showReveal
          ? `<div class="fya-overlay-reveal">reveal your arc <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M19 12l-7 7-7-7"/></svg></div>`
          : '';

        // Eyebrow only appears once 2+ selections are made — Q1 alone shows just the single line.
        const eyebrowHTML = overlayLines.length > 1 ? `<p class="fya-overlay-eyebrow">Your Selections</p>` : '';
        h += `<div class="fya-matrix-overlay" data-settled="${settled ? '1' : '0'}" style="${posCSS}">${eyebrowHTML}${overlayLines.join('')}${revealHTML}</div>`;
      }

      h += '</div>'; // /matrix-block
      return h;
    }
    function renderMatrixDescriptor(t, stage, stress) {
      // Mobile descriptor zone — empty (overlay carries the info).
      matrixDescrMobile.innerHTML = '';
      // Rail descriptor — Q-pages: hairline confirm card (eyebrow + first-person body). Locks visually on commit
      // via [data-fya-locked="1"] (CSS bolds + darkens). Reveal: named-Arc anchor — "Your RENEWAL ARC is called X".
      const stageKey = root.dataset.stage;
      const isReveal = stageKey === 'reveal';
      if (isReveal && t && stage && stress) {
        const arcName = (ARC_NAMES[t] && ARC_NAMES[t][stage]) ? ARC_NAMES[t][stage] : '';
        matrixDescr.innerHTML = `
          <div class="fya-arc-cap-row">
            <p class="fya-arc-cap-eyebrow">Your Arc</p>
            <p class="fya-arc-cap-meta">${TYPE_NAMES[t]} · ${STAGE_NAMES[stage]} · Stress ${STRESS_NAMES[stress]}</p>
          </div>
          <p class="fya-arc-cap-name">${arcName}</p>`;
        return;
      }
      // Q-page hairline format — eyebrow + first-person body. Lock state when answer committed.
      const buildHairline = (label, body, locked) => {
        const lockedAttr = locked ? '1' : '0';
        const borderClass = locked ? 'border-ochre/45' : 'border-line-soft';
        const eyebrowOpacity = locked ? 'text-fg/75' : 'text-fg/40';
        const bodyOpacity = locked ? 'text-fg/75' : 'text-fg/40';
        return `<div class="border-l ${borderClass} pl-5 py-1" data-fya-confirm-card data-fya-locked="${lockedAttr}">
                  <p class="font-sans uppercase tracking-[0.16em] text-[12px] ${eyebrowOpacity} mb-2" data-fya-confirm-eyebrow>${label}</p>
                  <p class="font-serif italic text-[17px] leading-[1.5] ${bodyOpacity}" data-fya-confirm-body>${body}</p>
                </div>`;
      };
      if (stageKey === 'q2') {
        matrixDescr.innerHTML = buildHairline('Skin Routine', stage ? STAGE_CONFIRM[stage] : 'I&rsquo;m&hellip;', !!stage);
      } else if (stageKey === 'q3') {
        matrixDescr.innerHTML = buildHairline('Stress Level', stress ? STRESS_CONFIRM[stress] : 'I&rsquo;m&hellip;', !!stress);
      } else {
        matrixDescr.innerHTML = buildHairline('Skin Type', t ? TYPE_CONFIRM[t] : 'My skin&hellip;', !!t);
      }
    }

    // ─── Navigation ───
    function goTo(key) {
      root.dataset.stage = key;
      Object.entries(panes).forEach(([k, el]) => { if (el) el.hidden = (k !== key); });
      framing.style.display = (key === 'gate' || key === 'reveal' || key === 'locking') ? 'none' : '';
      // Locking pane has its own contained render; populate + start the redirect sequence.
      if (key === 'locking') renderLocking();
      // H1 only shows on Q1; hides on Q2/Q3 (subtitle stays visible)
      const h1El = document.querySelector('[data-fya-h1]');
      if (h1El) h1El.style.display = (key === 'q1') ? '' : 'none';
      // Subtitle updates per stage
      const subEl = document.querySelector('[data-fya-subtitle]');
      if (subEl) subEl.textContent = SUBTITLES[key] || '';
      // Back-button label: Q1 = "Back to Ritual Care"; reveal = "Back" (Arc name shows in reveal-line); everywhere else = "Back"
      backLabel.textContent = (key === 'q1') ? 'Back to Ritual Care' : 'Back';
      // Desktop back-link mirrors label + hides on reveal
      const backDesktop      = document.querySelector('[data-fya-back-desktop]');
      const backLabelDesktop = document.querySelector('[data-fya-back-label-desktop]');
      if (backLabelDesktop) backLabelDesktop.textContent = (key === 'q1') ? 'Back to Ritual Care' : 'Back';
      if (backDesktop)      backDesktop.style.display = (key === 'reveal' || key === 'locking') ? 'none' : '';
      // Hide back button + sticky CTA during locking so the handoff feels final, not undo-able.
      if (backBtn)          backBtn.style.display = (key === 'locking') ? 'none' : '';
      if (sticky)           sticky.style.display = (key === 'locking') ? 'none' : '';
      // Desktop top-strip back-label — state-aware: Q1 + reveal = exit to Ritual Care, Q2/Q3 = back to prev step.
      const backStripLabel = document.querySelector('[data-fya-back-strip-label]');
      if (backStripLabel) {
        if (key === 'q1' || key === 'reveal') backStripLabel.textContent = 'Back to Ritual Care';
        else if (key === 'q2')                backStripLabel.textContent = 'Back to skin type';
        else if (key === 'q3')                backStripLabel.textContent = 'Back to skin practice';
      }
      // Reveal lead-line — shows below the progress bar on reveal only. Progress bar stays visible.
      const revealLine = document.querySelector('[data-fya-reveal-line]');
      if (revealLine) revealLine.hidden = (key !== 'reveal');
      // Desktop rail conversion panel — visible only on reveal so Save + Secure are above the fold.
      const railConv = document.querySelector('[data-fya-rail-conversion]');
      if (railConv) railConv.hidden = (key !== 'reveal');
      // Desktop rail ingredients — visible only on reveal (renderReveal populates content).
      const railIng = document.querySelector('[data-fya-rail-ingredients]');
      if (railIng) railIng.hidden = (key !== 'reveal');
      // Rail official elements — Renewal Matrix corner stamp only shows on reveal. (Your Arc cap eyebrow
       // is rendered inside the descriptor; no standalone toggle needed.)
      const railMatrixStamp = document.querySelector('[data-fya-rail-matrix-stamp]');
      if (railMatrixStamp) railMatrixStamp.hidden = (key !== 'reveal');
      // Header data-fya-stage drives reveal-mode top padding (Phase 0 = 50px above progress)
      const headerEl = document.querySelector('.fya-mobile-app-header');
      if (headerEl) {
        headerEl.dataset.fyaStage = key;
        if (key !== 'reveal') headerEl.dataset.collapsed = '0';
      }
      // Hide back button entirely on reveal (Preston lock 2026-06-01)
      backBtn.style.visibility = (key === 'reveal') ? 'hidden' : 'visible';
      // Hide the top mobile matrix on reveal (matrix drops down into the reveal pane)
      const topMatrixWrap = document.querySelector('[data-fya-matrix-mobile]')?.parentElement;
      if (topMatrixWrap) topMatrixWrap.style.display = (key === 'reveal') ? 'none' : '';

      setProgress(computeProgress(key, answers));

      if (key === 'gate')   renderGate();
      if (key === 'reveal') { removedSteps = new Set(); renderReveal(); }
      renderSticky();
      renderMatrix();
      window.scrollTo({ top: 0, behavior: 'instant' });
    }

    // Hover-preview teaser text per (stage, option) — shows what the pick would mean before the user commits.
    const HOVER_PREVIEW = {
      q1: {
        sensitive: 'Sensitive → The Calm family. 3 cells to choose from.',
        dry:       'Dry → The Hydrated family. 3 cells to choose from.',
        breakout:  'Oilier → The Clear family. 3 cells to choose from.'
      },
      q2: {
        rebuild:    'Foundation — 4 Steps, simple to keep.',
        reclaim:    'Layered — 7 Steps, calming work added.',
        revitalize: 'Restoration — 8 Steps, active correction on a stable base.'
      },
      q3: {
        low:    'Low stress — the barrier holds, the Arc moves with you.',
        medium: 'Workable load — the Ritual is the practice that brings it down.',
        high:   'Cortisol elevated — the Ritual is the steady line. Pace to breath.'
      }
    };

    // Phrase-bank anchor per stage — rotates a quiet italic line in the rail bottom. Reinforces voice register.
    const PHRASE_BANK_PER_STAGE = {
      q1: 'Care, chosen daily.',
      q2: 'What works requires repetition.',
      q3: 'Stay with it.',
      reveal: ''
    };
    function renderRailAnchor() {
      const key = root.dataset.stage;
      const anchor = document.querySelector('[data-fya-rail-anchor]');
      if (!anchor) return;
      anchor.textContent = PHRASE_BANK_PER_STAGE[key] || '';
    }

    // Rail "Next" sentence — refreshed on every answer pick + hover. Hover-preview takes priority when active
    // for the current stage (and current stage has no answer yet).
    function renderRailNext() {
      const key = root.dataset.stage;
      const railNext = document.querySelector('[data-fya-rail-next]');
      if (!railNext) return;
      const NEXT_BY_STAGE = {
        q1: "Pick your skin type. The row emerges.",
        q2: "Pick your routine stage. The column commits.",
        q3: "One more — cortisol names the cadence."
      };
      // Hover preview takes priority when current-stage answer not yet committed.
      const hover = root && root.dataset.hover;
      if (hover && key !== 'reveal') {
        const [hq, hv] = hover.split(':');
        const currentNotPicked = (key === hq) && !answers[hq];
        if (currentNotPicked && HOVER_PREVIEW[hq] && HOVER_PREVIEW[hq][hv]) {
          railNext.textContent = HOVER_PREVIEW[hq][hv];
          return;
        }
      }
      if (key === 'q1' && answers.q1)      railNext.textContent = "Continue. Your routine stage names the column.";
      else if (key === 'q2' && answers.q2) railNext.textContent = "Continue. Stress names the cadence within.";
      else                                 railNext.textContent = NEXT_BY_STAGE[key] || '';
    }

    function renderSticky() {
      const key = root.dataset.stage;
      renderRailNext();
      if (key === 'gate' || key === 'reveal') { sticky.style.transform = 'translateY(100%)'; return; }
      if (key === 'q1') {
        // Always visible on Q1 — placeholder until pick
        sticky.style.transform = 'translateY(0)';
        if (answers.q1) {
          stickyLabel.innerHTML = TYPE_CONFIRM[answers.q1];
          stickyLabel.style.opacity = '1';
          continueBtns.forEach(b => b.removeAttribute('disabled'));
          stickyText.textContent = 'Continue';
        } else {
          stickyLabel.innerHTML = 'My skin&hellip;';
          stickyLabel.style.opacity = '0.4';
          continueBtns.forEach(b => b.setAttribute('disabled', ''));
          stickyText.textContent = 'Continue';
        }
        return;
      }
      // Q2/Q3 — original slide-up-on-pick behavior, now with first-person phrases
      if (answers[key]) {
        sticky.style.transform = 'translateY(0)';
        stickyLabel.textContent = (key === 'q2') ? STAGE_CONFIRM[answers.q2] : STRESS_CONFIRM[answers.q3];
        stickyLabel.style.opacity = '1';
        continueBtns.forEach(b => b.removeAttribute('disabled'));
        stickyText.textContent = (key === 'q3') ? 'See your Arc' : 'Continue';
      } else {
        sticky.style.transform = 'translateY(100%)';
      }
    }

    function renderGate() {
      const t = answers.q1, s = answers.q2;
      document.querySelector('[data-fya-coord-prelude]').textContent = `${TYPE_NAMES[t]} · ${STAGE_NAMES[s]}`;
    }

    const TYPE_FULL = {
      sensitive: 'Sensitive · Reactive',
      dry:       'Dry · Normal',
      breakout:  'Breakout · Congested'
    };
    function renderReveal() {
      const t = answers.q1 || 'sensitive';
      const s = answers.q2 || 'reclaim';
      const stress = answers.q3 || 'steady';

      document.querySelector('[data-fya-coord-label]').textContent = `${TYPE_CAPTION[t]}, ${STAGE_CAPTION[s]}, ${STRESS_CAPTION[stress]}.`;
      document.querySelector('[data-fya-arc-name]').textContent = ARC_NAMES[t][s];

      // Education zone — coordinate-style key. Labels are static (Type / Practice / Stress); pick names
      // populate the right side of each label; bodies render TYPE_EDU / STAGE_EDU / STRESS_EDU.
      const eduTypePick   = document.querySelector('[data-fya-edu-type-pick]');
      const eduStagePick  = document.querySelector('[data-fya-edu-stage-pick]');
      const eduStressPick = document.querySelector('[data-fya-edu-stress-pick]');
      const eduTypeBody   = document.querySelector('[data-fya-edu-type-body]');
      const eduStageBody  = document.querySelector('[data-fya-edu-stage-body]');
      const eduStressBody = document.querySelector('[data-fya-edu-stress-body]');
      if (eduTypePick)   eduTypePick.textContent   = TYPE_NAMES[t];
      if (eduStagePick)  eduStagePick.textContent  = STAGE_NAMES[s];
      if (eduStressPick) eduStressPick.textContent = STRESS_NAMES[stress] || 'Medium';
      if (eduTypeBody)   eduTypeBody.textContent   = TYPE_EDU[t] || '';
      if (eduStageBody)  eduStageBody.textContent  = STAGE_EDU[s] || '';
      if (eduStressBody) eduStressBody.textContent = STRESS_EDU[stress] || STRESS_EDU.medium;

      // Narrative — single flowing paragraph per cell. Renders upright in Merriweather (official-descriptor feel).
      document.querySelector('[data-fya-narrative]').textContent = ARC_NARRATIVE[t][s];

      // Selections live in the matrix-overlay dialog (buildMatrixHTML), not on the reveal page.


      const arcEl = document.querySelector('[data-fya-arc]');
      arcEl.innerHTML = '';
      let runningTotal = 0;

      // Render the customer's stage as the Arc product list. Each row gets a per-product ✕ remove affordance.
      // Removed Steps skip rendering + drop out of the total. Remove-all triggers a UX swap in the rail
      // conversion panel (Save dominant, Secure de-emphasized).
      const arcOrder = ['cleanse','tone','prevent','treat','support','hydrateAm','hydratePm','protect'];
      const cellForCounting = MATRIX[t][s];
      const totalStepCount = arcOrder.filter(l => cellForCounting[l] && !cellForCounting[l].planned).length;
      const stagesToShow = [s];
      stagesToShow.forEach(st => {
        const cell = MATRIX[t][st];
        const group = document.createElement('div');
        // Desktop: hero-zone hairline already provides the visual break — drop the group's border + pt on lg.
        // No section header — body H2 already names the Arc; redundant heading here would crowd the page.
        group.className = 'pt-6 border-t border-line-soft lg:pt-2 lg:border-t-0';
        group.innerHTML = '';
        const list = document.createElement('ul');
        list.className = 'space-y-5 lg:grid lg:grid-cols-2 lg:gap-x-6 lg:gap-y-4 lg:space-y-0';
        arcOrder.forEach(step => {
          const p = cell[step];
          if (!p) return;
          if (removedSteps.has(step)) return; // customer de-curated this Step
          if (!p.planned) runningTotal += p.price;
          const ampm = (step === 'hydrateAm') ? ' · AM' : (step === 'hydratePm') ? ' · PM' : '';
          const handle = PROD[p.name];
          const price = p.planned ? '—' : `$${p.price}`;
          const li = document.createElement('li');
          li.className = 'grid grid-cols-[60px_1fr_auto] gap-4 items-start';
          // Image + name both link to PDP (when handle exists and product is shipped, not planned)
          const imgPlaceholder = `<div class="w-[60px] h-[60px] bg-line-soft/50 border border-line-soft rounded-md flex items-center justify-center text-[9px] tracking-[0.14em] uppercase text-muted/70">${p.planned ? 'soon' : 'img'}</div>`;
          const imgEl = (p.image && !p.planned)
            ? `<img src="${p.image}" alt="${p.name}" loading="lazy" class="block w-[60px] h-[60px] object-cover rounded-md bg-bg-cream border border-line-soft">`
            : imgPlaceholder;
          const productUrl = p.url || (handle ? `/products/${handle}` : null);
          const imgBlock = (productUrl && !p.planned)
            ? `<a href="${productUrl}" target="_blank" rel="noopener" class="block hover:opacity-80 transition-opacity">${imgEl}</a>`
            : imgEl;
          const stepDesc = (STEP_DESCRIBED[t] && STEP_DESCRIBED[t][step]) || '';
          const curationLine = stepDesc ? `Chosen for your Arc. ${stepDesc}` : 'Chosen for your Arc.';
          li.innerHTML = `
            ${imgBlock}
            <div class="min-w-0">
              <p class="font-sans tracking-[0.08em] text-[12px] text-fg/70 uppercase mb-1">${STEP_LABEL[step]}${ampm}</p>
              ${handle && !p.planned
                ? `<a href="/products/${handle}" target="_blank" rel="noopener" class="font-serif text-[18px] text-fg hover:text-accent transition-colors leading-[1.3]">${p.name}</a>`
                : `<p class="font-serif italic text-[18px] text-muted leading-[1.3]">${p.name}${p.planned ? ' · planned' : ''}</p>`}
              <p class="font-serif italic text-[15.5px] leading-[1.55] text-fg/75 mt-1.5">${curationLine}</p>
              <p class="font-sans text-[12px] text-muted mt-1">${p.vol}</p>
            </div>
            <div class="fya-arc-row-right flex flex-col items-end gap-1">
              <span class="font-sans text-[15px] text-fg whitespace-nowrap">${price}</span>
            </div>
            <button class="fya-row-remove" data-fya-remove="${step}" aria-label="Remove ${STEP_LABEL[step]} step" title="Remove">&times;</button>
          `;
          li.classList.add('fya-arc-row');
          list.appendChild(li);
        });
        group.appendChild(list);
        arcEl.appendChild(group);
      });

      // Wire per-product remove buttons (re-render on click — running through renderReveal recalculates totals
      // + re-evaluates the remove-all UX swap).
      arcEl.querySelectorAll('[data-fya-remove]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          removedSteps.add(btn.dataset.fyaRemove);
          renderReveal();
        });
      });

      // Scripture renderer — reads APPLY_NARRATIVE[type][stage][am|pm] for the customer's cell. Emits centered
      // chapter heading (AM / PM small caps) + italic preface + numbered verses with hanging numerals.
      // Each {wordmark} replaced by footnote-letter-prefixed hølyX link (a,b,c... in Burnished Ochre,
      // mirroring scripture cross-reference letters). Cadence panel keeps simple prose.
      const cellSteps = MATRIX[t][s];
      const renderScriptureWordmark = (step, p, footIdx) => {
        const baseStep = (step === 'hydrateAm' || step === 'hydratePm') ? 'hydrate' : step;
        const handle = PROD[p.name] || '';
        const letter = String.fromCharCode(97 + footIdx); // 0→a, 1→b, 2→c...
        const inner = `<sup class="fya-scripture-footnote">${letter}</sup>høly${baseStep}`;
        if (handle && !p.planned) {
          return `<a class="fya-scripture-link" data-fya-product-handle="${handle}" href="/products/${handle}" target="_blank" rel="noopener">${inner}</a>`;
        }
        return `<span class="fya-scripture-link">${inner}</span>`;
      };
      const renderScripturePanel = (isPm) => {
        const data = (APPLY_NARRATIVE[t] && APPLY_NARRATIVE[t][s] && APPLY_NARRATIVE[t][s][isPm ? 'pm' : 'am']) || null;
        if (!data) return '';
        let versesHTML = '';
        let footIdx = 0;
        data.verses.forEach((verse, i) => {
          const p = cellSteps[verse.step];
          if (!p) return; // safety: skip if Step not in this cell (shouldn't happen with the canon-correct narratives)
          const wordmark = renderScriptureWordmark(verse.step, p, footIdx);
          const text = verse.text.replace('{wordmark}', wordmark);
          versesHTML += `<li class="fya-scripture-verse"><span class="fya-verse-num">${footIdx + 1}</span><span class="fya-verse-body">${text}</span></li>`;
          footIdx += 1;
        });
        return `
          <div class="fya-scripture">
            <p class="fya-scripture-chapter">${isPm ? 'PM' : 'AM'}</p>
            <p class="fya-scripture-preface">${data.preface}</p>
            <ol class="fya-scripture-verses">${versesHTML}</ol>
          </div>`;
      };
      const applyAm = document.querySelector('[data-fya-apply-panel="am"]');
      const applyPm = document.querySelector('[data-fya-apply-panel="pm"]');
      const applyCadence = document.querySelector('[data-fya-apply-panel="cadence"]');
      if (applyAm)      applyAm.innerHTML      = renderScripturePanel(false);
      if (applyPm)      applyPm.innerHTML      = renderScripturePanel(true);
      // Cadence — per-cell paragraph, plain helpful voice. Not scripture-formatted. Reads as a calm guide.
      if (applyCadence) {
        const cadenceText = (APPLY_CADENCE_CELL[t] && APPLY_CADENCE_CELL[t][s]) || APPLY_CADENCE[stress] || APPLY_CADENCE.medium;
        applyCadence.innerHTML = `<p class="fya-cadence-body">${cadenceText}</p>`;
      }

      // Provision · Support upsell — render the 4 face-Support Provision SKUs
      const provisionEl = document.querySelector('[data-fya-provision]');
      provisionEl.innerHTML = '';
      PROVISION_SUPPORT.forEach(p => {
        const li = document.createElement('li');
        li.className = 'grid grid-cols-[60px_1fr_auto] gap-4 items-start';
        const imgPlaceholder = `<div class="w-[60px] h-[60px] bg-line-soft/40 border border-line-soft rounded-md flex items-center justify-center text-[9px] tracking-[0.14em] uppercase text-muted/70">img</div>`;
        const imgBlock = `<a href="/products/${p.handle}" target="_blank" rel="noopener" class="block hover:opacity-80 transition-opacity">${imgPlaceholder}</a>`;
        li.innerHTML = `
          ${imgBlock}
          <div class="min-w-0">
            <a href="/products/${p.handle}" target="_blank" rel="noopener" class="font-serif text-[18px] text-fg hover:text-accent transition-colors leading-[1.35]">${p.name}</a>
            <p class="font-serif italic text-[15.5px] leading-[1.55] text-fg/80 mt-1.5">${p.tag}</p>
            <p class="font-sans text-[13px] text-muted mt-1">${p.vol}</p>
          </div>
          <button type="button" class="fya-provision-add font-sans text-[13px] tracking-[0.04em] text-fg/85 hover:text-accent border border-line hover:border-accent rounded-full px-3.5 py-2 whitespace-nowrap transition-colors" data-fya-provision-add data-handle="${p.handle}">+ $${p.price}</button>
        `;
        provisionEl.appendChild(li);
      });

      // Product count reflects remaining (non-removed, non-planned) Steps in the customer's cell.
      const activeSteps = arcOrder.filter(l => MATRIX[t][s][l] && !MATRIX[t][s][l].planned && !removedSteps.has(l));
      const productCount = activeSteps.length;
      const arPrice = Math.round(runningTotal * (1 - AR_DISCOUNT));
      const isAllRemoved = (productCount === 0);
      document.querySelector('[data-fya-total-label]').textContent = `Your Arc · ${productCount} products`;
      document.querySelector('[data-fya-total-price]').textContent = `$${runningTotal}`;
      document.querySelector('[data-fya-total-ar]').textContent    = `$${arPrice}`;
      document.querySelector('[data-fya-secure-label]').textContent = isAllRemoved ? 'Restore all Steps' : 'Join the waitlist';

      // Desktop rail conversion panel — mirror totals + Secure label (Save form is uncontrolled, no sync needed).
      const railConvPanel  = document.querySelector('[data-fya-rail-conversion]');
      const railTotalLabel = document.querySelector('[data-fya-total-label-rail]');
      const railTotalPrice = document.querySelector('[data-fya-total-price-rail]');
      const railTotalAr    = document.querySelector('[data-fya-total-ar-rail]');
      const railSecureLbl  = document.querySelector('[data-fya-secure-label-rail]');
      if (railTotalLabel) railTotalLabel.textContent = `Your Arc · ${productCount} products`;
      if (railTotalPrice) railTotalPrice.textContent = `$${runningTotal}`;
      if (railTotalAr)    railTotalAr.textContent    = `$${arPrice}`;
      if (railSecureLbl)  railSecureLbl.textContent  = isAllRemoved ? 'Restore all Steps' : 'Join the waitlist';
      // Remove-all UX swap — Save dominant, Secure de-emphasized (rail).
      if (railConvPanel) railConvPanel.dataset.allRemoved = isAllRemoved ? '1' : '0';

      // Mobile conversion — mirror totals + secure label + remove-all swap so the mobile block behaves like
      // the rail. The Secure button label is already wired via data-fya-secure-label above.
      const mobileConvPanel = document.querySelector('[data-fya-mobile-conversion]');
      if (mobileConvPanel) mobileConvPanel.dataset.allRemoved = isAllRemoved ? '1' : '0';
      // Mobile Type·Stage·Stress meta (mirrors the rail cap meta — mobile only since cap renders inline on body).
      const mobileCoord = document.querySelector('[data-fya-arc-coord-mobile]');
      if (mobileCoord) mobileCoord.textContent = `${TYPE_NAMES[t]} · ${STAGE_NAMES[s]} · Stress ${STRESS_NAMES[stress]}`;

      // Clinical Actives — populate both rail (desktop, always visible) and mobile (collapsible) lists.
      const slugify = (n) => n.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
      const cellIngs = (RAIL_INGREDIENTS[t] && RAIL_INGREDIENTS[t][s]) || [];
      const ingListEl = document.querySelector('[data-fya-rail-ingredients-list]');
      if (ingListEl) {
        const rows = cellIngs.map(ing => `
          <div class="py-2.5 border-t border-line-soft/70 first:border-t-0 first:pt-0">
            <a href="/pages/actives/${slugify(ing.name)}" class="font-sans text-[13.5px] tracking-[0.04em] text-fg/90 hover:text-accent transition-colors block mb-0.5 underline decoration-line-soft underline-offset-[3px] decoration-[0.5px]" data-fya-active-link>${ing.name}</a>
            <p class="font-serif italic text-[13.5px] leading-[1.5] text-fg/65">${ing.role}</p>
          </div>`).join('');
        ingListEl.innerHTML = rows;
      }
      const mobileActivesList = document.querySelector('[data-fya-actives-mobile-list]');
      if (mobileActivesList) {
        const rows = cellIngs.map(ing => `
          <div class="py-3 border-t border-line-soft/70 first:border-t-0 first:pt-0">
            <a href="/pages/actives/${slugify(ing.name)}" class="font-sans text-[14px] tracking-[0.04em] text-fg/90 block mb-1 underline decoration-line-soft underline-offset-[3px]">${ing.name}</a>
            <p class="font-serif italic text-[15px] leading-[1.55] text-fg/70">${ing.role}</p>
          </div>`).join('');
        mobileActivesList.innerHTML = rows;
      }
    }

    // ─── Event wiring ───
    document.querySelectorAll('[data-fya-q]').forEach(btn => {
      btn.addEventListener('click', () => {
        const q = btn.dataset.fyaQ;
        const v = btn.dataset.fyaValue;
        answers[q] = v;
        // Clear any hover state — the click commits the value, hover preview no longer applicable.
        delete root.dataset.hover;
        btn.closest('[data-fya-pane]').querySelectorAll('[data-fya-q]').forEach(b => b.dataset.selected = '0');
        btn.dataset.selected = '1';
        renderSticky();
        renderMatrix();
        setProgress(computeProgress(root.dataset.stage, answers));
        // Lock-flash — only on Q3 (the locking moment). Re-fire on any Q3 change so the affordance still appears
        // if the user switches their stress pick. Animation auto-clears via `forwards` keyframe.
        if (q === 'q3') {
          const flash = document.querySelector('[data-fya-lock-flash]');
          if (flash) {
            flash.removeAttribute('data-active');
            // Force reflow so re-adding the attribute restarts the animation.
            void flash.offsetWidth;
            flash.dataset.active = '1';
          }
        }
      });
      // ─── Hover-preview wiring (desktop pattern). Touch users still get the click commit; the brief mouseenter
      //     on tap is benign — it gets cleared by the click handler above. ───
      btn.addEventListener('mouseenter', () => {
        const q = btn.dataset.fyaQ;
        const v = btn.dataset.fyaValue;
        // Only preview if the current stage matches the hovered question AND it isn't already committed.
        if (q !== root.dataset.stage) return;
        if (answers[q]) return;
        root.dataset.hover = `${q}:${v}`;
        renderMatrix();
        renderRailNext();
      });
      btn.addEventListener('mouseleave', () => {
        const q = btn.dataset.fyaQ;
        if (q !== root.dataset.stage) return;
        if (answers[q]) return;
        if (!root.dataset.hover) return;
        delete root.dataset.hover;
        renderMatrix();
        renderRailNext();
      });
    });

    // Practice tab wiring — click toggles active tab + reveals matching panel + updates explanatory subtitle.
    const PANEL_SUBTITLE = {
      am:      'Your morning ritual. Prep + defend before the day.',
      pm:      'Your evening ritual. Repair + restore through the night.',
      cadence: 'The rhythm. What to repeat, when to add, when to receive.'
    };
    document.querySelectorAll('[data-fya-apply-tab]').forEach(tabBtn => {
      tabBtn.addEventListener('click', () => {
        const tabKey = tabBtn.dataset.fyaApplyTab;
        document.querySelectorAll('[data-fya-apply-tab]').forEach(b => b.dataset.active = (b.dataset.fyaApplyTab === tabKey) ? '1' : '0');
        document.querySelectorAll('[data-fya-apply-panel]').forEach(p => {
          if (p.dataset.fyaApplyPanel === tabKey) p.removeAttribute('hidden');
          else p.setAttribute('hidden', '');
        });
        const subtitleEl = document.querySelector('[data-fya-panel-subtitle]');
        if (subtitleEl) subtitleEl.textContent = PANEL_SUBTITLE[tabKey] || '';
      });
    });

    continueBtns.forEach(btn => btn.addEventListener('click', () => {
      const key = root.dataset.stage;
      if (key === 'q1' && answers.q1) goTo('q2');
      else if (key === 'q2' && answers.q2) goTo('q3');
      else if (key === 'q3' && answers.q3) goTo('reveal'); // gate dropped — direct to reveal
    }));

    function backHandler(e) {
      const key = root.dataset.stage;
      if (key === 'q1' || key === 'reveal') { window.location.href = '/'; return; }
      e?.preventDefault?.();
      if (key === 'q2') goTo('q1');
      else if (key === 'q3') goTo('q2');
    }
    backBtn.addEventListener('click', backHandler);
    const backBtnDesktop = document.querySelector('[data-fya-back-desktop]');
    if (backBtnDesktop) backBtnDesktop.addEventListener('click', backHandler);
    // Desktop top-strip back — same handler, state-aware destination via backHandler's stage routing.
    const backStripBtn = document.querySelector('[data-fya-back-strip]');
    if (backStripBtn) backStripBtn.addEventListener('click', backHandler);

    // ─── Secure your Arc → waitlist intercept (2026-06-06) ───
    // Pre-launch posture: the DTC purchase pathway is intercepted into a Klaviyo waitlist
    // sign-up rather than checkout. The Secure click takes the email already entered in the
    // Save form (mobile or rail), posts to /apps/booking/waitlist (Shopify App Proxy →
    // booking.holyaxis.com worker) with source='map-your-skin' + Arc context, then surfaces
    // the locking pane as a "saved" confirmation. If no email is in the Save field, flash +
    // focus it so the user enters one before retry.
    async function secureArc(sourceLabel) {
      const emailSel = sourceLabel === 'rail' ? '[data-fya-save-email-rail]' : '[data-fya-save-email]';
      const emailEl = document.querySelector(emailSel);
      const email = ((emailEl && emailEl.value) || '').trim();
      if (!email) {
        if (emailEl) {
          emailEl.focus();
          emailEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      return submitWaitlist(sourceLabel, email);
    }

    // Shared waitlist submitter — used by Secure (mobile + rail) and Save (mobile + rail).
    async function submitWaitlist(triggerLabel, email) {
      const t = answers.q1, s = answers.q2, st = answers.q3 || '';
      const cell = (t && s && MATRIX[t]) ? MATRIX[t][s] : null;
      const arcName = (t && s) ? (ARC_NAMES?.[t]?.[s] || '') : '';
      const order = ['cleanse','tone','prevent','treat','support','hydrateAm','hydratePm','protect'];
      const products = [];
      if (cell) {
        order.forEach(step => {
          if (removedSteps.has(step)) return;
          const p = cell[step];
          if (p && !p.planned && p.handle) products.push(p.handle);
        });
      }
      // Show locking pane immediately for the anticipatory frame (rendered as waitlist-saved).
      goTo('locking');
      try {
        const res = await fetch('/apps/booking/waitlist', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            email: email.toLowerCase(),
            source: 'map-your-skin',
            consent_marketing: true,
            arc: { arc_name: arcName, skin_type: t || '', stage: s || '', stress: st, products }
          })
        });
        if (!res.ok) {
          const text = await res.text().catch(() => '');
          console.error('[fya] waitlist failed:', res.status, text);
          cancelLockingRedirect('We hit a snag saving your Arc. Refresh and try again.');
          return;
        }
        console.log('[fya] waitlist saved (' + triggerLabel + ')');
        // Locking pane stays — no redirect. Copy already reflects saved state via renderLocking().
      } catch (err) {
        console.error('[fya] waitlist error:', err);
        cancelLockingRedirect("We couldn't reach the waitlist. Check your connection and try again.");
      }
    }

    // Cancel locking-pane redirect (cart-add failed). Show error + manual retry button.
    function cancelLockingRedirect(message) {
      lockingTimers.forEach(id => clearTimeout(id));
      lockingTimers = [];
      const errorEl = document.querySelector('[data-fya-locking-error]');
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = message;
      }
      // Re-style fallback button as retry-back-to-reveal
      const fallbackBtn = document.querySelector('[data-fya-locking-fallback]');
      if (fallbackBtn) {
        fallbackBtn.hidden = false;
        fallbackBtn.firstElementChild.textContent = 'Back to your Arc';
        fallbackBtn.onclick = () => { goTo('reveal'); };
      }
      // Hide the "Taking you to checkout…" line — the redirect isn't happening.
      const lineEl = document.querySelector('.fya-locking-line');
      if (lineEl) lineEl.style.display = 'none';
    }

    // ─── Locking pane render (2026-06-06 — waitlist-saved mode) ───
    // Pre-launch posture: locking pane confirms the Arc is saved to the waitlist instead of
    // committing to checkout. Shows Arc name + step list (no prices, no totals, no redirect).
    let lockingTimers = [];
    function renderLocking() {
      // Defensive: clear any prior timers in case the pane was previously entered in
      // checkout-mode and timers are still pending. This codepath shouldn't queue any new
      // timers — the pane is now a terminal success state.
      lockingTimers.forEach(id => clearTimeout(id));
      lockingTimers = [];

      const t = answers.q1;
      const s = answers.q2;
      if (!t || !s) return;
      const cell = MATRIX[t][s];
      const order = ['cleanse','tone','prevent','treat','support','hydrateAm','hydratePm','protect'];

      // Eyebrow + arc name + step list — same shape as before, minus prices.
      const eyebrowEl = document.querySelector('.fya-locking-eyebrow');
      if (eyebrowEl) eyebrowEl.innerHTML = 'Your Renewal Arc is saved';

      const nameEl = document.querySelector('[data-fya-locking-arc-name]');
      if (nameEl) nameEl.textContent = ARC_NAMES[t][s];

      const list = document.querySelector('[data-fya-locking-list]');
      if (list) {
        list.innerHTML = '';
        order.forEach(step => {
          if (removedSteps.has(step)) return;
          const p = cell[step];
          if (!p || p.planned) return;
          const ampm = (step === 'hydrateAm') ? ' · AM' : (step === 'hydratePm') ? ' · PM' : '';
          const li = document.createElement('li');
          li.innerHTML = `
            <span class="fya-locking-step">${STEP_LABEL[step]}${ampm}</span>
            <span class="fya-locking-name">${p.name}</span>
          `;
          list.appendChild(li);
        });
      }

      // Hide total row (no money exchanged in waitlist mode).
      const totalRow = document.querySelector('.fya-locking-total-row');
      if (totalRow) totalRow.style.display = 'none';

      // Rewrite the disclosure + closing line copy from "Taking you to checkout" to waitlist.
      const disclosureEl = document.querySelector('.fya-locking-disclosure');
      if (disclosureEl) disclosureEl.textContent = "We'll cue you when the doors open. No promotions.";
      const lineEl = document.querySelector('.fya-locking-line');
      if (lineEl) lineEl.textContent = 'We have your Arc.';

      // Reset error visibility.
      const errorEl = document.querySelector('[data-fya-locking-error]');
      if (errorEl) errorEl.hidden = true;

      // Hide the checkout fallback button — no checkout target in waitlist mode.
      const fallbackBtn = document.querySelector('[data-fya-locking-fallback]');
      if (fallbackBtn) {
        fallbackBtn.hidden = true;
        fallbackBtn.onclick = null;
      }
    }

    // ─── Wordmark hover product card popover (desktop only) ───
    // Hovering an .fya-scripture-link with [data-fya-product-handle] surfaces a small card with
    // image · name · vol · price · view-product link. Reads window.FYA_DATA.products[handle].
    (function bindWordmarkHover() {
      const card = document.querySelector('[data-fya-wordmark-card]');
      if (!card) return;
      const cardImg   = card.querySelector('[data-fya-wordmark-card-img]');
      const cardStep  = card.querySelector('[data-fya-wordmark-card-step]');
      const cardName  = card.querySelector('[data-fya-wordmark-card-name]');
      const cardMeta  = card.querySelector('[data-fya-wordmark-card-meta]');
      const cardLink  = card.querySelector('[data-fya-wordmark-card-link]');
      let hideTimer = null;

      const hide = () => {
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => { card.dataset.visible = '0'; }, 120);
      };
      const show = (link) => {
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        const handle = link.getAttribute('data-fya-product-handle');
        if (!handle || !LIVE || !LIVE.products || !LIVE.products[handle]) return;
        const live = LIVE.products[handle];
        // Step inferred from the wordmark text (e.g., "hølycleanse" → cleanse)
        const wordmarkText = (link.textContent || '').toLowerCase().replace(/[^a-z]/g, '');
        const stepMatch = wordmarkText.match(/høly?([a-z]+)/) || wordmarkText.match(/holy([a-z]+)/);
        const stepRaw = stepMatch ? stepMatch[1].replace(/tm$/, '') : '';
        if (cardImg) {
          if (live.image) { cardImg.src = live.image; cardImg.alt = live.title || ''; cardImg.hidden = false; }
          else { cardImg.hidden = true; }
        }
        if (cardStep) cardStep.textContent = stepRaw.toUpperCase();
        if (cardName) cardName.textContent = live.title || '';
        if (cardMeta) cardMeta.textContent = (live.vol || '') + ' · $' + (live.price || '0');
        if (cardLink) cardLink.href = live.url || ('/products/' + handle);
        // Position the card above the link, centered horizontally on the link's midpoint.
        const rect = link.getBoundingClientRect();
        const cardW = 280;
        const cardH = 110; // approximate; refined by content
        let left = rect.left + window.scrollX + (rect.width / 2) - (cardW / 2);
        let top  = rect.top + window.scrollY - cardH - 12;
        // Keep within viewport bounds
        const minLeft = 12, maxLeft = window.innerWidth - cardW - 12;
        if (left < minLeft) left = minLeft;
        if (left > maxLeft) left = maxLeft;
        if (top < window.scrollY + 12) top = rect.bottom + window.scrollY + 12; // flip below
        card.style.left = left + 'px';
        card.style.top  = top + 'px';
        card.dataset.visible = '1';
      };

      // Delegated hover via mouseover/mouseout (capture wordmark links anywhere)
      document.addEventListener('mouseover', (e) => {
        const link = e.target.closest('.fya-scripture-link[data-fya-product-handle]');
        if (link) show(link);
      });
      document.addEventListener('mouseout', (e) => {
        const link = e.target.closest('.fya-scripture-link[data-fya-product-handle]');
        if (link) hide();
      });
      // Keep card visible while mouse is on the card itself
      card.addEventListener('mouseenter', () => { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } });
      card.addEventListener('mouseleave', hide);
    })();

    // Save form handler (2026-06-06) — converges with Secure on the same waitlist endpoint.
    function saveFormHandler(e, emailSelector) {
      e.preventDefault();
      const email = ((document.querySelector(emailSelector) || {}).value || '').trim();
      if (!email) return;
      const trigger = emailSelector.includes('rail') ? 'save-rail' : 'save-mobile';
      submitWaitlist(trigger, email);
    }
    document.querySelector('[data-fya-save-form]').addEventListener('submit', (e) =>
      saveFormHandler(e, '[data-fya-save-email]')
    );
    // Mobile Secure button — separate from Save form (matches rail pattern). Cart add; restore-all on empty.
    const mobileSecureBtn = document.querySelector('[data-fya-secure]');
    if (mobileSecureBtn) mobileSecureBtn.addEventListener('click', () => {
      const mobileConv = document.querySelector('[data-fya-mobile-conversion]');
      if (mobileConv && mobileConv.dataset.allRemoved === '1') {
        removedSteps = new Set();
        renderReveal();
        return;
      }
      secureArc('mobile');
    });
    const railSaveForm = document.querySelector('[data-fya-save-form-rail]');
    if (railSaveForm) railSaveForm.addEventListener('submit', (e) =>
      saveFormHandler(e, '[data-fya-save-email-rail]')
    );
    const railSecureBtn = document.querySelector('[data-fya-secure-rail]');
    if (railSecureBtn) railSecureBtn.addEventListener('click', () => {
      // Remove-all state: clicking the de-emphasized Secure link restores all Steps.
      const railConvPanel = document.querySelector('[data-fya-rail-conversion]');
      if (railConvPanel && railConvPanel.dataset.allRemoved === '1') {
        removedSteps = new Set();
        renderReveal();
        return;
      }
      secureArc('rail');
    });

    // Cart icon — legacy handler; if it's still in the DOM, route through secureArc for consistency.
    const cartBtn = document.querySelector('[data-fya-cart]');
    if (cartBtn) cartBtn.addEventListener('click', () => secureArc('cart-icon'));

    // Legacy gate form (kept for safety; gate pane is bypassed in navigation)
    const gateForm = document.querySelector('[data-fya-gate-form]');
    if (gateForm) gateForm.addEventListener('submit', (e) => { e.preventDefault(); goTo('reveal'); });

    // ─── Reveal close X (appears when sticky header dissolves in Phase 2) ───
    const headerX = document.querySelector('[data-fya-header-x]');
    if (headerX) headerX.addEventListener('click', () => { window.location.href = '/'; });

    // ─── Rail "Read the system" expand/collapse — depth content lives behind this affordance per progressive
    //     disclosure best practice. Default collapsed. Each stage transition leaves the user's expand state alone. ───
    const railDepthTrigger = document.querySelector('[data-fya-depth-trigger]');
    const railDepthPanel   = document.querySelector('[data-fya-depth-panel]');
    if (railDepthTrigger && railDepthPanel) {
      railDepthTrigger.addEventListener('click', () => {
        const open = railDepthTrigger.getAttribute('aria-expanded') === 'true';
        const chevron = railDepthTrigger.querySelector('.fya-rail-depth-chevron');
        if (open) {
          railDepthPanel.style.maxHeight = '0';
          railDepthTrigger.setAttribute('aria-expanded', 'false');
          if (chevron) chevron.textContent = '+';
        } else {
          railDepthPanel.style.maxHeight = railDepthPanel.scrollHeight + 'px';
          railDepthTrigger.setAttribute('aria-expanded', 'true');
          if (chevron) chevron.textContent = '−';
        }
      });
    }

    // ─── Provision expand/collapse ───
    const provisionTrigger = document.querySelector('[data-fya-provision-trigger]');
    const provisionPanel   = document.querySelector('[data-fya-provision-panel]');
    if (provisionTrigger && provisionPanel) {
      provisionTrigger.addEventListener('click', () => {
        const open = provisionTrigger.getAttribute('aria-expanded') === 'true';
        if (open) {
          provisionPanel.style.maxHeight = '0';
          provisionTrigger.setAttribute('aria-expanded', 'false');
          provisionTrigger.querySelector('.fya-provision-chevron').textContent = '+';
        } else {
          provisionPanel.style.maxHeight = provisionPanel.scrollHeight + 'px';
          provisionTrigger.setAttribute('aria-expanded', 'true');
          provisionTrigger.querySelector('.fya-provision-chevron').textContent = '−';
        }
      });
    }

    // ─── Mobile Clinical Actives expand/collapse ───
    const activesMobileTrigger = document.querySelector('[data-fya-actives-mobile-trigger]');
    const activesMobilePanel   = document.querySelector('[data-fya-actives-mobile-panel]');
    if (activesMobileTrigger && activesMobilePanel) {
      activesMobileTrigger.addEventListener('click', () => {
        const open = activesMobileTrigger.getAttribute('aria-expanded') === 'true';
        if (open) {
          activesMobilePanel.style.maxHeight = '0';
          activesMobileTrigger.setAttribute('aria-expanded', 'false');
          activesMobileTrigger.querySelector('.fya-actives-mobile-chevron').textContent = '+';
        } else {
          activesMobilePanel.style.maxHeight = activesMobilePanel.scrollHeight + 'px';
          activesMobileTrigger.setAttribute('aria-expanded', 'true');
          activesMobileTrigger.querySelector('.fya-actives-mobile-chevron').textContent = '−';
        }
      });
    }

    // ─── Reveal header scroll behavior ───
    // Phase 0 (default): full header — back row, ~50px top padding, progress bar, "Your Renewal Arc Is ↓" line.
    // Phase 1 (scrollY > 30): top padding above progress bar trims; everything else stays visible.
    // The X only appears when the bottom of the reveal content reaches the viewport — see IntersectionObserver below.
    const _headerEl = document.querySelector('.fya-mobile-app-header');
    let _collapseTicking = false;
    window.addEventListener('scroll', () => {
      if (_collapseTicking) return;
      _collapseTicking = true;
      requestAnimationFrame(() => {
        if (_headerEl && root.dataset.stage === 'reveal') {
          _headerEl.dataset.collapsed = (window.scrollY > 30) ? '1' : '0';
        }
        _collapseTicking = false;
      });
    }, { passive: true });

    // ─── X visibility — appears when the bottom of the reveal content enters the viewport ───
    // Sentinel: the Secure CTA. Once it enters view, the user has reached the page bottom — show X.
    // Watches every reveal entry; resets on exit-from-reveal.
    let _bottomObserver = null;
    function setupBottomXObserver() {
      // Watch the References footer (visible on both mobile + desktop, sits at the very bottom of the reveal content).
      // On mobile this fires after the user scrolls past Secure; on desktop after they scroll past the References block.
      const sentinel = document.querySelector('[data-fya-pane="reveal"] a[href="/pages/research"]');
      if (!sentinel || !_headerEl) return;
      if (_bottomObserver) _bottomObserver.disconnect();
      _bottomObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          _headerEl.dataset.fyaShowX = entry.isIntersecting ? '1' : '0';
        });
      }, { threshold: 0.2 });
      _bottomObserver.observe(sentinel);
    }
    function teardownBottomXObserver() {
      if (_bottomObserver) { _bottomObserver.disconnect(); _bottomObserver = null; }
      if (_headerEl) _headerEl.dataset.fyaShowX = '0';
    }
    const _origGoToForX = goTo;
    goTo = function(key) {
      teardownBottomXObserver();
      _origGoToForX(key);
      if (key === 'reveal') {
        requestAnimationFrame(() => setupBottomXObserver());
      }
    };

    // ─── Mobile-header tablet+ kill (JS belt-and-braces in case the CSS + Tailwind md:hidden don't take) ───
    const mobileHeaderEl = document.querySelector('.fya-mobile-app-header');
    function syncMobileHeaderVisibility() {
      if (!mobileHeaderEl) return;
      const isTabletPlus = window.matchMedia('(min-width: 768px)').matches;
      mobileHeaderEl.style.display = isTabletPlus ? 'none' : '';
    }
    syncMobileHeaderVisibility();
    window.addEventListener('resize', syncMobileHeaderVisibility, { passive: true });

    // ─── Init ───
    goTo('q1');
  })();
